/******/ (() => { // webpackBootstrap
/* eslint-disable */
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}
document.addEventListener('DOMContentLoaded', function () {
  const isThemeEditor = !!(window.Shopify && window.Shopify.designMode);
  let miniCartGoogleWidgetObserver;
  const syncMiniCartGoogleWidgetState = () => {
    const miniCartDrawer = document.getElementById('mini-cart-drawer');
    const isMiniCartActive = !!(
      miniCartDrawer
      && (
        miniCartDrawer.classList.contains('active_link')
        || miniCartDrawer.classList.contains('is-theme-editor-preview')
      )
    );

    document.documentElement.classList.toggle('mini-cart-active', isMiniCartActive);

    if (document.body) {
      document.body.classList.toggle('mini-cart-active', isMiniCartActive);
    }
  };
  const observeMiniCartGoogleWidgetState = () => {
    const miniCartDrawer = document.getElementById('mini-cart-drawer');

    if (miniCartGoogleWidgetObserver) {
      miniCartGoogleWidgetObserver.disconnect();
      miniCartGoogleWidgetObserver = null;
    }

    if (!miniCartDrawer) {
      syncMiniCartGoogleWidgetState();
      return;
    }

    miniCartGoogleWidgetObserver = new MutationObserver(mutations => {
      const hasRelevantMutation = mutations.some(mutation => mutation.type === 'attributes' && mutation.attributeName === 'class');

      if (hasRelevantMutation) {
        syncMiniCartGoogleWidgetState();
        if (miniCartDrawer.classList.contains('active_link') || miniCartDrawer.classList.contains('is-theme-editor-preview')) {
          refreshMiniCartJoyInline({ forceRemount: true, delay: 150 });
        }
      }
    });

    miniCartGoogleWidgetObserver.observe(miniCartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    syncMiniCartGoogleWidgetState();
    refreshMiniCartJoyInline({ forceRemount: true, delay: 150 });
  };
  let miniCartJoyRefreshTimer;
  let miniCartJoyCartSyncTimer;
  let miniCartSignatureRewardsRefreshTimer;
  let miniCartSignatureRewardsRequestToken = 0;
  let miniCartSignatureRewardsShippingRefreshTimer;
  let miniCartSignatureRewardsShippingRefreshAttempt = 0;
  let miniCartShippingEstimateRequestToken = 0;
  let miniCartSignatureRewardsStateCache = null;
  let miniCartJoyTriggerWrapAttempts = 0;
  const miniCartSignatureRewardsShippingRefreshDelays = [400, 1200, 2600, 5000, 9000];
  const miniCartSignatureRewardsStorageKey = 'pxu:mini-cart-signature-reward';
  const miniCartSignatureRewardsMaxRedeemablePoints = 10000;
  const miniCartSignatureRewardsCartAttributeKeys = {
    couponCode: '__pxu_signature_reward_coupon_code',
    title: '__pxu_signature_reward_title',
    rewardId: '__pxu_signature_reward_id',
    programId: '__pxu_signature_reward_program_id'
  };
  const miniCartShippingEstimateState = {
    status: 'idle',
    amount: null,
    requestKey: '',
    cart: null
  };
  const miniCartUsFlatShippingCents = 800;
  const miniCartUsFreeShippingThresholdCents = 6000;
  const getMiniCartSignatureRewardsStoredReward = () => {
    if (!window.sessionStorage) {
      return null;
    }
    try {
      const storedValue = window.sessionStorage.getItem(miniCartSignatureRewardsStorageKey);
      if (!storedValue) {
        return null;
      }
      const parsedValue = JSON.parse(storedValue);
      return parsedValue && typeof parsedValue === 'object' ? parsedValue : null;
    } catch (error) {
      return null;
    }
  };
  const miniCartSignatureRewardsUiState = {
    expanded: false,
    selectedProgramId: '',
    pointsInput: '',
    appliedRewardSnapshot: getMiniCartSignatureRewardsStoredReward()
  };
  const miniCartSignatureRewardsFeaturedUiState = {
    selectedProgramId: '',
    pointsInput: ''
  };
  const miniCartEscapeHtml = value => $('<div/>').text(value == null ? '' : String(value)).html();
  const getMiniCartSignatureRewardsUndoIconMarkup = () => '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 7H5v4" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.9"/><path d="M5 11c1.5-3.1 4.8-5.2 8.4-5.2 4.9 0 8.9 4 8.9 8.9s-4 8.9-8.9 8.9c-2.4 0-4.7-1-6.4-2.8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.9"/></svg>';
  const getMiniCartJoyInlineBlocks = () => Array.from(document.querySelectorAll('#mini-cart-drawer .joy-redeem-inline'));
  const getMiniCartSignatureRewardsBlocks = () => Array.from(document.querySelectorAll('#mini-cart-drawer [data-mini-cart-signature-rewards]'));
  const getMiniCartSignatureRewardsFeaturedBlocks = () => Array.from(document.querySelectorAll('#mini-cart-drawer [data-mini-cart-signature-rewards-featured]'));
  const getMiniCartSignatureRewardsMarkupHost = block => {
    if (!block) {
      return null;
    }
    if (block.matches('[data-mini-cart-signature-rewards-content]')) {
      return block;
    }
    return block.querySelector('[data-mini-cart-signature-rewards-content]');
  };
  const getMiniCartSignatureRewardsFeaturedMarkupHost = block => {
    if (!block) {
      return null;
    }
    if (block.matches('[data-mini-cart-signature-rewards-featured-content]')) {
      return block;
    }
    return block.querySelector('[data-mini-cart-signature-rewards-featured-content]');
  };
  const getMiniCartSignatureRewardsTierSourceBlock = () => {
    return getMiniCartSignatureRewardsFeaturedBlocks()[0]
      || getMiniCartSignatureRewardsBlocks()[0]
      || null;
  };
  const getMiniCartSignatureRewardsButtonStyle = () => {
    const block = getMiniCartSignatureRewardsBlocks()[0];
    return String(block && block.dataset && block.dataset.miniCartSignatureRewardsButtonStyle || '').trim()
      || 'global-button--secondary';
  };
  const getMiniCartSignatureRewardsFeaturedButtonStyle = () => {
    const block = getMiniCartSignatureRewardsFeaturedBlocks()[0];
    return String(block && block.dataset && block.dataset.miniCartSignatureRewardsButtonStyle || '').trim()
      || 'global-button--secondary';
  };
  const closeMiniCartBeforeJoyWidget = () => {
    if (window.header && typeof window.header.closeMiniCart === 'function') {
      window.header.closeMiniCart();
      return;
    }
    $('.cart-container').removeClass('active_link');
    $('#mini-cart-drawer').removeClass('active_link');
    $('body').removeClass('is-active blocked-scroll');
  };
  const wrapGlobalJoyTrigger = () => {
    if (typeof window.avadaJoyTrigger !== 'function' || window.avadaJoyTrigger.__miniCartWrapped) {
      return false;
    }
    const originalJoyTrigger = window.avadaJoyTrigger;
    const wrappedJoyTrigger = function () {
      closeMiniCartBeforeJoyWidget();
      return originalJoyTrigger.apply(this, arguments);
    };
    wrappedJoyTrigger.__miniCartWrapped = true;
    window.avadaJoyTrigger = wrappedJoyTrigger;
    return true;
  };
  const scheduleMiniCartJoyTriggerWrap = () => {
    if (wrapGlobalJoyTrigger()) {
      return;
    }
    if (miniCartJoyTriggerWrapAttempts >= 20) {
      return;
    }
    miniCartJoyTriggerWrapAttempts += 1;
    window.setTimeout(scheduleMiniCartJoyTriggerWrap, 250);
  };
  const renderMiniCartSignatureRewardsMarkup = markup => {
    getMiniCartSignatureRewardsBlocks().forEach(block => {
      const markupHost = getMiniCartSignatureRewardsMarkupHost(block);
      if (!markupHost) {
        return;
      }
      markupHost.innerHTML = markup;
    });
  };
  const renderMiniCartSignatureRewardsFeaturedMarkup = markup => {
    getMiniCartSignatureRewardsFeaturedBlocks().forEach(block => {
      const markupHost = getMiniCartSignatureRewardsFeaturedMarkupHost(block);
      if (!markupHost) {
        return;
      }
      markupHost.innerHTML = markup;
    });
  };
  const getMiniCartSignatureRewardsErrorMessage = (error, fallbackMessage) => {
    if (!error) {
      return fallbackMessage;
    }
    if (typeof error === 'string') {
      return error;
    }
    const responseJson = error.responseJSON || error.responseJson || {};
    const responseData = error.responseData || {};
    return responseJson.message
      || responseJson.description
      || responseData.message
      || responseData.description
      || error.message
      || fallbackMessage;
  };
  const normalizeMiniCartSignatureRewardsValue = value => String(value || '').trim().toLowerCase();
  const formatMiniCartSignatureRewardsTitle = value => String(value || '')
    .trim()
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  const getMiniCartSignatureRewardsCurrencyCode = () => {
    const currencyCode = $('[data-cart-form="mini-cart"]').first().data('shopCurrency')
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || 'USD';
    return String(currencyCode || 'USD').trim().toUpperCase();
  };
  const formatMiniCartSignatureRewardsCurrency = amount => {
    const numericAmount = Number(amount) || 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: getMiniCartSignatureRewardsCurrencyCode(),
        minimumFractionDigits: Number.isInteger(numericAmount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(numericAmount);
    } catch (error) {
      const fixedAmount = Number.isInteger(numericAmount) ? numericAmount.toString() : numericAmount.toFixed(2);
      return `$${fixedAmount}`;
    }
  };
  const getMiniCartSignatureRewardsPointLabel = (count, branding = {}) => {
    const singularLabel = String(branding.pointSingular || 'Gem').trim() || 'Gem';
    const pluralLabel = String(branding.pointPlural || `${singularLabel}s`).trim() || `${singularLabel}s`;
    return Number(count) === 1 ? singularLabel : pluralLabel;
  };
  const formatMiniCartSignatureRewardsPoints = (count, branding = {}) => {
    const numericCount = Number(count) || 0;
    return `${numericCount.toLocaleString()} ${getMiniCartSignatureRewardsPointLabel(numericCount, branding)}`;
  };
  const extractMiniCartSignatureRewardsAmountFromTitle = title => {
    const titleString = String(title || '').trim();
    const moneyMatch = titleString.match(/\$([\d,.]+)/);
    if (!moneyMatch) {
      return 0;
    }
    return parseFloat(String(moneyMatch[1]).replace(/,/g, '')) || 0;
  };
  const extractMiniCartSignatureRewardsPercentFromTitle = title => {
    const titleString = String(title || '').trim();
    const percentMatch = titleString.match(/([\d.]+)%/);
    if (!percentMatch) {
      return 0;
    }
    return parseFloat(percentMatch[1]) || 0;
  };
  const normalizeMiniCartSignatureRewardsProgram = program => {
    const title = String(program && program.title ? program.title : 'Reward').trim();
    const titleValue = normalizeMiniCartSignatureRewardsValue(title);
    const eventName = String(program && program.event ? program.event : '').trim().toLowerCase();
    const redeemType = String(program && program.redeemType ? program.redeemType : '').trim().toLowerCase();
    const appliedTo = String(program && program.appliedTo ? program.appliedTo : '').trim().toLowerCase();
    const programType = String(program && program.type ? program.type : '').trim().toLowerCase();
    const redeemIn = String(program && program.redeemIn ? program.redeemIn : '').trim().toLowerCase();
    const rewardType = String(program && program.rewardType ? program.rewardType : '').trim().toLowerCase();
    const discountType = String(program && program.discountType ? program.discountType : '').trim().toLowerCase();
    const discountTargetType = String(program && program.discountTargetType ? program.discountTargetType : '').trim().toLowerCase();
    const couponType = String(program && program.couponType ? program.couponType : '').trim().toLowerCase();
    const actionType = String(program && program.actionType ? program.actionType : '').trim().toLowerCase();
    const isPercentage = eventName.includes('percentage') || /%/.test(title);
    const rewardAmount = Number(program && program.earnAmount);
    const amountFromTitle = extractMiniCartSignatureRewardsAmountFromTitle(title);
    const parsedRewardAmount = Number.isFinite(rewardAmount) && rewardAmount > 0
      ? rewardAmount
      : (isPercentage ? extractMiniCartSignatureRewardsPercentFromTitle(title) : amountFromTitle);
    const isDynamic = redeemType !== '' && redeemType !== 'fixed';
    const shippingSignals = [
      titleValue,
      eventName,
      redeemType,
      appliedTo,
      programType,
      redeemIn,
      rewardType,
      discountType,
      discountTargetType,
      couponType,
      actionType
    ].filter(Boolean).join(' ');
    const isFreeShipping = titleValue.includes('free shipping')
      || eventName.includes('free_shipping')
      || appliedTo.includes('shipping')
      || redeemIn.includes('shipping')
      || shippingSignals.includes('shipping_discount')
      || (/\bshipping\b/.test(shippingSignals) && !isDynamic && parsedRewardAmount === 0 && !isPercentage);
    const normalizedProgram = {
      raw: program || {},
      id: String(program && program.id ? program.id : '').trim(),
      title,
      minimumPoints: Math.max(Number(program && program.spendPoint) || 0, 0),
      rewardAmount: parsedRewardAmount,
      eventName,
      appliedTo,
      programType,
      redeemIn,
      redeemType,
      isDynamic,
      isFreeShipping,
      isPercentage,
      isMonetary: !isFreeShipping && !isPercentage && parsedRewardAmount > 0
    };
    if (normalizedProgram.isFreeShipping) {
      normalizedProgram.previewKind = 'shipping';
    } else if (normalizedProgram.isPercentage) {
      normalizedProgram.previewKind = 'percentage';
    } else if (normalizedProgram.isMonetary) {
      normalizedProgram.previewKind = 'currency';
    } else {
      normalizedProgram.previewKind = 'title';
    }
    return normalizedProgram;
  };
  const normalizeMiniCartSignatureRewardsPrograms = programs => (Array.isArray(programs) ? programs : [])
    .map(normalizeMiniCartSignatureRewardsProgram)
    .filter(isMiniCartSignatureRewardsSupportedProgram)
    .sort(sortMiniCartSignatureRewardsPrograms);
  const didMiniCartSignatureRewardsProgramsChange = (currentPrograms, nextPrograms) => {
    const createSignature = programs => JSON.stringify((Array.isArray(programs) ? programs : []).map(program => ({
      id: String(program && program.id ? program.id : ''),
      title: String(program && program.title ? program.title : ''),
      minimumPoints: Number(program && program.minimumPoints) || 0,
      isDynamic: !!(program && program.isDynamic),
      isFreeShipping: !!(program && program.isFreeShipping)
    })));
    return createSignature(currentPrograms) !== createSignature(nextPrograms);
  };
  const isMiniCartSignatureRewardsSupportedProgram = program => {
    if (!program || program.raw.status === false) {
      return false;
    }
    if (!program.id) {
      return false;
    }
    if (program.programType && program.programType !== 'spending') {
      return false;
    }
    if (program.eventName === 'free_gift') {
      return false;
    }
    if (program.appliedTo === 'sf_product') {
      return false;
    }
    if (program.redeemIn && !program.redeemIn.includes('online_store')) {
      return false;
    }
    return true;
  };
  const sortMiniCartSignatureRewardsPrograms = (programA, programB) => {
    if (programA.isDynamic !== programB.isDynamic) {
      return programA.isDynamic ? -1 : 1;
    }
    if (programA.minimumPoints !== programB.minimumPoints) {
      return programA.minimumPoints - programB.minimumPoints;
    }
    return programA.title.localeCompare(programB.title);
  };
  const getMiniCartSignatureRewardsPreviewText = (program, pointsValue) => {
    if (!program) {
      return '';
    }
    const numericPoints = Math.max(Number(pointsValue) || 0, 0);
    const pointsMultiplierBase = Math.max(program.minimumPoints || 0, 1);
    const pointsMultiplier = program.isDynamic ? numericPoints / pointsMultiplierBase : 1;
    if (program.previewKind === 'shipping') {
      const normalizedTitle = normalizeMiniCartSignatureRewardsValue(program.title);
      if (!normalizedTitle || normalizedTitle === 'free shipping') {
        return 'Free Standard U.S. Shipping';
      }
      return program.title;
    }
    if (program.previewKind === 'percentage') {
      const percentAmount = (program.rewardAmount || 0) * Math.max(pointsMultiplier, 0);
      return `${percentAmount.toLocaleString()}%`;
    }
    if (program.previewKind === 'currency') {
      const rewardValue = (program.rewardAmount || 0) * Math.max(pointsMultiplier, 0);
      return formatMiniCartSignatureRewardsCurrency(rewardValue);
    }
    return program.title;
  };
  const getMiniCartSignatureRewardsPreviewDetailText = program => {
    if (!program) {
      return '';
    }
    if (program.previewKind === 'shipping' && program.rewardAmount > 0) {
      return formatMiniCartSignatureRewardsCurrency(program.rewardAmount);
    }
    return '';
  };
  const getMiniCartSignatureRewardsRewardCode = reward => {
    const candidates = [
      reward && reward.couponCode,
      reward && reward.code,
      reward && reward.discountCode,
      reward && reward.coupon && reward.coupon.code,
      reward && reward.discount && reward.discount.code
    ];
    return candidates
      .map(candidate => String(candidate || '').trim())
      .find(Boolean) || '';
  };
  const getMiniCartSignatureRewardsRewardTitle = reward => {
    const candidates = [
      reward && reward.programTitle,
      reward && reward.programDescription,
      reward && reward.program && reward.program.title,
      reward && reward.title
    ];
    return candidates
      .map(candidate => String(candidate || '').trim())
      .find(Boolean) || '';
  };
  const getMiniCartSignatureRewardsRewardId = reward => {
    const candidates = [
      reward && reward.id,
      reward && reward.rewardId
    ];
    return candidates
      .map(candidate => String(candidate || '').trim())
      .find(Boolean) || '';
  };
  const getMiniCartSignatureRewardsHydratedReward = (reward, fallbackReward = null) => {
    if (!(reward || fallbackReward)) {
      return null;
    }
    const mergedReward = Object.assign(
      {},
      fallbackReward && typeof fallbackReward === 'object' ? fallbackReward : {},
      reward && typeof reward === 'object' ? reward : {}
    );
    const resolvedRewardId = getMiniCartSignatureRewardsRewardId(reward) || getMiniCartSignatureRewardsRewardId(fallbackReward);
    const resolvedProgramId = String(
      (reward && reward.programId)
      || (fallbackReward && fallbackReward.programId)
      || ''
    ).trim();
    const resolvedRewardTitle = getMiniCartSignatureRewardsRewardTitle(reward) || getMiniCartSignatureRewardsRewardTitle(fallbackReward);
    const resolvedCouponCode = getMiniCartSignatureRewardsRewardCode(reward) || getMiniCartSignatureRewardsRewardCode(fallbackReward);
    return Object.assign(mergedReward, {
      id: resolvedRewardId,
      rewardId: resolvedRewardId,
      programId: resolvedProgramId,
      programTitle: resolvedRewardTitle,
      couponCode: resolvedCouponCode
    });
  };
  const doesMiniCartSignatureRewardsRewardMatchStoredReward = (reward, storedReward) => {
    if (!(reward && storedReward)) {
      return false;
    }
    const rewardId = normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardId(reward));
    const storedId = normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardId(storedReward));
    if (rewardId && storedId && rewardId === storedId) {
      return true;
    }
    const rewardCode = normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardCode(reward));
    const storedCode = normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardCode(storedReward));
    if (rewardCode && storedCode && rewardCode === storedCode) {
      return true;
    }
    const rewardTitle = normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardTitle(reward));
    const storedTitle = normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardTitle(storedReward));
    return !!(rewardTitle && storedTitle && rewardTitle === storedTitle);
  };
  const getMiniCartSignatureRewardsRewardMatchTokens = reward => [
    getMiniCartSignatureRewardsRewardCode(reward),
    getMiniCartSignatureRewardsRewardTitle(reward)
  ]
    .map(normalizeMiniCartSignatureRewardsValue)
    .filter(Boolean);
  const getMiniCartCartAttributes = cart => {
    return cart && cart.attributes && typeof cart.attributes === 'object'
      ? cart.attributes
      : {};
  };
  const getMiniCartCartAttributeValue = (cart, key) => {
    const attributes = getMiniCartCartAttributes(cart);
    return String(attributes && attributes[key] ? attributes[key] : '').trim();
  };
  const mergeMiniCartCartAttributes = (cart, overrides = {}) => {
    return Object.assign({}, getMiniCartCartAttributes(cart), overrides || {});
  };
  const getMiniCartSignatureRewardsCartSnapshot = cart => {
    const couponCode = getMiniCartCartAttributeValue(cart, miniCartSignatureRewardsCartAttributeKeys.couponCode);
    const title = getMiniCartCartAttributeValue(cart, miniCartSignatureRewardsCartAttributeKeys.title);
    const rewardId = getMiniCartCartAttributeValue(cart, miniCartSignatureRewardsCartAttributeKeys.rewardId);
    const programId = getMiniCartCartAttributeValue(cart, miniCartSignatureRewardsCartAttributeKeys.programId);
    if (!(couponCode || title || rewardId || programId)) {
      return null;
    }
    return {
      id: rewardId,
      rewardId,
      programId,
      programTitle: title,
      couponCode
    };
  };
  const getMiniCartSignatureRewardsCartAttributesPayload = reward => {
    const normalizedReward = reward || {};
    return {
      [miniCartSignatureRewardsCartAttributeKeys.couponCode]: getMiniCartSignatureRewardsRewardCode(normalizedReward),
      [miniCartSignatureRewardsCartAttributeKeys.title]: getMiniCartSignatureRewardsRewardTitle(normalizedReward),
      [miniCartSignatureRewardsCartAttributeKeys.rewardId]: getMiniCartSignatureRewardsRewardId(normalizedReward),
      [miniCartSignatureRewardsCartAttributeKeys.programId]: String(normalizedReward && normalizedReward.programId ? normalizedReward.programId : '').trim()
    };
  };
  const getMiniCartSignatureRewardsClearedCartAttributesPayload = () => {
    return {
      [miniCartSignatureRewardsCartAttributeKeys.couponCode]: '',
      [miniCartSignatureRewardsCartAttributeKeys.title]: '',
      [miniCartSignatureRewardsCartAttributeKeys.rewardId]: '',
      [miniCartSignatureRewardsCartAttributeKeys.programId]: ''
    };
  };
  const doesMiniCartSignatureRewardsDiscountMatchReward = (discount, reward) => {
    if (!(discount && reward)) {
      return false;
    }
    const rewardMatches = getMiniCartSignatureRewardsRewardMatchTokens(reward);
    if (!rewardMatches.length) {
      return false;
    }
    const discountTitle = normalizeMiniCartSignatureRewardsValue(discount && discount.title);
    return !!(discountTitle && rewardMatches.includes(discountTitle));
  };
  const persistMiniCartSignatureRewardsAppliedReward = reward => {
    const normalizedReward = reward ? {
      id: getMiniCartSignatureRewardsRewardId(reward),
      programId: String(reward && reward.programId ? reward.programId : '').trim(),
      programTitle: getMiniCartSignatureRewardsRewardTitle(reward),
      couponCode: getMiniCartSignatureRewardsRewardCode(reward)
    } : null;
    miniCartSignatureRewardsUiState.appliedRewardSnapshot = normalizedReward;
    if (!window.sessionStorage) {
      return;
    }
    try {
      if (normalizedReward) {
        window.sessionStorage.setItem(miniCartSignatureRewardsStorageKey, JSON.stringify(normalizedReward));
      } else {
        window.sessionStorage.removeItem(miniCartSignatureRewardsStorageKey);
      }
    } catch (error) {
      // Ignore storage failures and keep the in-memory snapshot only.
    }
  };
  const clearMiniCartSignatureRewardsAppliedReward = () => {
    persistMiniCartSignatureRewardsAppliedReward(null);
  };
  const getMiniCartSignatureRewardsTierName = () => {
    const tierSourceBlock = getMiniCartSignatureRewardsTierSourceBlock();
    const tierName = tierSourceBlock && tierSourceBlock.dataset
      ? String(tierSourceBlock.dataset.miniCartSignatureRewardsTierName || '').trim()
      : '';
    if (tierName) {
      return tierName;
    }
    return '';
  };
  const normalizeMiniCartSignatureRewardsTier = tier => {
    return {
      raw: tier || {},
      id: String(tier && tier.id ? tier.id : '').trim(),
      name: String(tier && tier.name ? tier.name : '').trim(),
      systemType: String(tier && tier.systemType ? tier.systemType : '').trim(),
      icon: String((tier && (tier.iconCustom || tier.icon)) || '').trim()
    };
  };
  const getMiniCartSignatureRewardsCurrentTier = tiers => {
    const tierName = getMiniCartSignatureRewardsTierName();
    const normalizedTierName = normalizeMiniCartSignatureRewardsValue(tierName);
    const availableTiers = Array.isArray(tiers) ? tiers : [];
    if (!normalizedTierName) {
      return {
        name: '',
        badgeUrl: ''
      };
    }
    const matchedTier = availableTiers.find(tier => {
      const normalizedName = normalizeMiniCartSignatureRewardsValue(tier && tier.name);
      const normalizedSystemType = normalizeMiniCartSignatureRewardsValue(tier && tier.systemType);
      return normalizedTierName === normalizedName || normalizedTierName === normalizedSystemType;
    }) || null;
    return {
      name: tierName,
      badgeUrl: matchedTier ? String(matchedTier.icon || '').trim() : ''
    };
  };
  const getMiniCartSignatureRewardsFeaturedDatasetValue = key => {
    const featuredBlock = getMiniCartSignatureRewardsFeaturedBlocks()[0];
    return featuredBlock && featuredBlock.dataset
      ? String(featuredBlock.dataset[key] || '').trim()
      : '';
  };
  const getMiniCartSignatureRewardsFeaturedFallbackBadgeUrl = tierName => {
    const normalizedTierName = normalizeMiniCartSignatureRewardsValue(tierName);
    if (normalizedTierName === 'member') {
      return getMiniCartSignatureRewardsFeaturedDatasetValue('miniCartSignatureRewardsMemberBadge');
    }
    if (normalizedTierName === 'insider') {
      return getMiniCartSignatureRewardsFeaturedDatasetValue('miniCartSignatureRewardsInsiderBadge');
    }
    if (normalizedTierName === 'icon') {
      return getMiniCartSignatureRewardsFeaturedDatasetValue('miniCartSignatureRewardsIconBadge');
    }
    return '';
  };
  const getMiniCartSignatureRewardsFeaturedHeading = () => {
    return getMiniCartSignatureRewardsFeaturedDatasetValue('miniCartSignatureRewardsHeading') || 'Signature Rewards';
  };
  const formatMiniCartSignatureRewardsSavingsCurrency = amount => {
    const numericAmount = Number(amount) || 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: getMiniCartSignatureRewardsCurrencyCode(),
        minimumFractionDigits: Number.isInteger(numericAmount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(numericAmount);
    } catch (error) {
      return Number.isInteger(numericAmount)
        ? `$${numericAmount}`
        : `$${numericAmount.toFixed(2)}`;
    }
  };
  const getMiniCartSignatureRewardsFeaturedPrograms = state => {
    const availablePrograms = getMiniCartSignatureRewardsAvailablePrograms(state);
    const dynamicProgram = availablePrograms.find(program => program.isDynamic && program.isMonetary) || availablePrograms.find(program => program.isDynamic) || null;
    const shippingProgram = availablePrograms.find(program => program.isFreeShipping)
      || availablePrograms.find(program => normalizeMiniCartSignatureRewardsValue(program.title).includes('shipping'))
      || availablePrograms.find(program => !program.isDynamic)
      || null;
    return {
      availablePrograms,
      dynamicProgram,
      shippingProgram,
      rewardOptions: [shippingProgram, dynamicProgram].filter(Boolean)
    };
  };
  const getMiniCartSignatureRewardsFeaturedSelectedProgram = (state, rewardOptions) => {
    const options = Array.isArray(rewardOptions) ? rewardOptions : [];
    if (!options.length) {
      miniCartSignatureRewardsFeaturedUiState.selectedProgramId = '';
      return null;
    }
    let selectedProgram = options.find(program => program.id === miniCartSignatureRewardsFeaturedUiState.selectedProgramId) || null;
    if (!selectedProgram) {
      selectedProgram = options.find(program => program.isDynamic) || options[0] || null;
      miniCartSignatureRewardsFeaturedUiState.selectedProgramId = selectedProgram ? selectedProgram.id : '';
    }
    return selectedProgram;
  };
  const getMiniCartSignatureRewardsProgramRedeemPointCap = (program, customerPoints) => {
    if (!(program && program.isDynamic)) {
      return Math.max(Number(customerPoints) || 0, 0);
    }
    const step = Math.max(program.minimumPoints || 1, 1);
    const customerCap = Math.max(Math.floor(Math.max(Number(customerPoints) || 0, 0) / step) * step, 0);
    const programCap = Math.floor(miniCartSignatureRewardsMaxRedeemablePoints / step) * step;
    if (!customerCap || programCap <= 0) {
      return 0;
    }
    return Math.min(customerCap, programCap);
  };
  const getMiniCartSignatureRewardsFeaturedDefaultPoints = (program, customerPoints) => {
    if (!(program && program.isDynamic)) {
      return '';
    }
    const step = Math.max(program.minimumPoints || 100, 1);
    const max = getMiniCartSignatureRewardsProgramRedeemPointCap(program, customerPoints);
    if (max < step) {
      return '';
    }
    return '0';
  };
  const ensureMiniCartSignatureRewardsFeaturedDynamicPointsInput = (program, customerPoints) => {
    if (!(program && program.isDynamic)) {
      return;
    }
    const step = Math.max(program.minimumPoints || 100, 1);
    const max = getMiniCartSignatureRewardsProgramRedeemPointCap(program, customerPoints);
    const sanitizedInput = String(miniCartSignatureRewardsFeaturedUiState.pointsInput || '').replace(/[^\d]/g, '');
    const currentValue = sanitizedInput === '' ? NaN : parseInt(sanitizedInput, 10);
    if (!Number.isFinite(currentValue) || currentValue < 0 || (max > 0 && currentValue > max)) {
      miniCartSignatureRewardsFeaturedUiState.pointsInput = getMiniCartSignatureRewardsFeaturedDefaultPoints(program, customerPoints);
    }
  };
  const getMiniCartSignatureRewardsFeaturedDynamicState = (program, customerPoints) => {
    if (!(program && program.isDynamic)) {
      return null;
    }
    const step = Math.max(program.minimumPoints || 100, 1);
    const max = getMiniCartSignatureRewardsProgramRedeemPointCap(program, customerPoints);
    if (max < step) {
      return null;
    }
    const min = 0;
    let value = parseInt(String(miniCartSignatureRewardsFeaturedUiState.pointsInput || '').replace(/[^\d]/g, ''), 10);
    if (!Number.isFinite(value) || value < min) {
      value = min;
    }
    value = value > 0 ? Math.round(value / step) * step : 0;
    value = Math.max(min, Math.min(value, max));
    const saveAmount = (Number(program.rewardAmount) || 0) * (value / step);
    return {
      min,
      max,
      step,
      value,
      saveAmount,
      isCapped: Number(customerPoints) > max
    };
  };
  const resetMiniCartSignatureRewardsFeaturedSelection = state => {
    const customerPoints = Number(state && state.customer && state.customer.point) || 0;
    const { rewardOptions, dynamicProgram } = getMiniCartSignatureRewardsFeaturedPrograms(state || {});
    const defaultProgram = (Array.isArray(rewardOptions) ? rewardOptions : []).find(program => program.isDynamic) || dynamicProgram || rewardOptions[0] || null;
    miniCartSignatureRewardsFeaturedUiState.selectedProgramId = defaultProgram ? defaultProgram.id : '';
    miniCartSignatureRewardsFeaturedUiState.pointsInput = '';
    ensureMiniCartSignatureRewardsFeaturedDynamicPointsInput(defaultProgram, customerPoints);
  };
  const getMiniCartSignatureRewardsFeaturedContext = state => {
    const customerPoints = Number(state && state.customer && state.customer.point) || 0;
    const { availablePrograms, dynamicProgram, shippingProgram, rewardOptions } = getMiniCartSignatureRewardsFeaturedPrograms(state);
    const appliedReward = getMiniCartSignatureRewardsAppliedReward(state && state.rewards, state && state.cart);
    const selectedProgram = getMiniCartSignatureRewardsFeaturedSelectedProgram(state, rewardOptions);
    ensureMiniCartSignatureRewardsFeaturedDynamicPointsInput(selectedProgram, customerPoints);
    const dynamicState = getMiniCartSignatureRewardsFeaturedDynamicState(dynamicProgram, customerPoints);
    if (selectedProgram && selectedProgram.isDynamic && dynamicState) {
      miniCartSignatureRewardsFeaturedUiState.pointsInput = String(dynamicState.value);
    }
    return {
      customerPoints,
      availablePrograms,
      dynamicProgram,
      shippingProgram,
      rewardOptions,
      appliedReward,
      selectedProgram,
      dynamicState,
      hasRedeemablePrograms: rewardOptions.length > 0
    };
  };
  const getMiniCartSignatureRewardsFeaturedFallbackIconMarkup = (datasetKey, fallbackMarkup) => {
    const iconUrl = getMiniCartSignatureRewardsFeaturedDatasetValue(datasetKey);
    if (!iconUrl) {
      return fallbackMarkup;
    }
    return `<img src="${miniCartEscapeHtml(iconUrl)}" alt="" loading="lazy">`;
  };
  const getMiniCartSignatureRewardsFeaturedIcons = () => {
    const defaultGemIconMarkup = '<img src="https://cdn.shopify.com/s/files/1/0694/3771/files/joy_Teal_Icon_80px.png?v=1773351911" alt="" loading="lazy">';
    const defaultTruckIconMarkup = '<svg viewBox="0 0 40 28" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.1"><path d="M3 6h19v11H3z"/><path d="M22 10h7l5 5v2h-12z"/><path d="M9 21.5a3.5 3.5 0 1 1 0 .1zm20 0a3.5 3.5 0 1 1 0 .1z"/><path d="M14 6V3h8v6"/></g></svg>';
    return {
      balanceGem: defaultGemIconMarkup,
      shopGem: getMiniCartSignatureRewardsFeaturedFallbackIconMarkup('miniCartSignatureRewardsShopIcon', defaultGemIconMarkup),
      truck: getMiniCartSignatureRewardsFeaturedFallbackIconMarkup('miniCartSignatureRewardsShippingIcon', defaultTruckIconMarkup),
      minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>',
      plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>'
    };
  };
  const getMiniCartSignatureRewardsProgramIconUrl = program => {
    const rawProgram = program && program.raw ? program.raw : {};
    const candidates = [
      rawProgram && rawProgram.iconCustom && rawProgram.iconCustom.url,
      rawProgram && rawProgram.iconCustom && rawProgram.iconCustom.src,
      rawProgram && rawProgram.iconCustom,
      rawProgram && rawProgram.icon && rawProgram.icon.url,
      rawProgram && rawProgram.icon && rawProgram.icon.src,
      rawProgram && rawProgram.icon,
      rawProgram && rawProgram.iconUrl,
      rawProgram && rawProgram.iconURL,
      rawProgram && rawProgram.imageBlock && rawProgram.imageBlock.url,
      rawProgram && rawProgram.imageBlock && rawProgram.imageBlock.src,
      rawProgram && rawProgram.imageBlock,
      rawProgram && rawProgram.imageUrl,
      rawProgram && rawProgram.imageURL,
      rawProgram && rawProgram.image && rawProgram.image.src,
      rawProgram && rawProgram.media && rawProgram.media.url,
      rawProgram && Array.isArray(rawProgram.specificProducts) && rawProgram.specificProducts[0] && rawProgram.specificProducts[0].image && rawProgram.specificProducts[0].image.src
    ];
    return candidates
      .map(candidate => String(candidate || '').trim())
      .find(candidate => /^https?:\/\//i.test(candidate) || /^\/\//.test(candidate) || /^\//.test(candidate)) || '';
  };
  const getMiniCartSignatureRewardsProgramIconMarkup = (program, fallbackMarkup) => {
    const iconUrl = getMiniCartSignatureRewardsProgramIconUrl(program);
    if (!iconUrl) {
      return fallbackMarkup;
    }
    return `<img src="${miniCartEscapeHtml(iconUrl)}" alt="" loading="lazy">`;
  };
  const doesMiniCartSignatureRewardMatchCart = (reward, cart) => {
    if (!reward) {
      return false;
    }
    const rewardMatchTokens = getMiniCartSignatureRewardsRewardMatchTokens(reward);
    if (!rewardMatchTokens.length) {
      return false;
    }
    const appliedDiscountTitles = getMiniCartCartLevelDiscountTitles(cart).map(normalizeMiniCartSignatureRewardsValue);
    return appliedDiscountTitles.some(title => rewardMatchTokens.includes(title));
  };
  const doesMiniCartSignatureRewardsCartHaveDiscount = cart => {
    return !!(getMiniCartSignatureRewardsCartSnapshot(cart) || (Number(cart && cart.total_discount) || 0) > 0 || (cart && Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length));
  };
  const getMiniCartSignatureRewardsAvailablePrograms = state => {
    const customerPoints = Number(state && state.customer && state.customer.point) || 0;
    return (Array.isArray(state && state.programs) ? state.programs : [])
      .filter(program => customerPoints >= program.minimumPoints);
  };
  const getMiniCartSignatureRewardsPreferredProgram = programs => programs.find(program => program.isDynamic) || programs[0] || null;
  const getMiniCartSignatureRewardsSelectedProgram = programs => {
    if (!Array.isArray(programs) || !programs.length) {
      miniCartSignatureRewardsUiState.selectedProgramId = '';
      return null;
    }
    let selectedProgram = programs.find(program => program.id === miniCartSignatureRewardsUiState.selectedProgramId) || null;
    if (!selectedProgram) {
      selectedProgram = getMiniCartSignatureRewardsPreferredProgram(programs);
      miniCartSignatureRewardsUiState.selectedProgramId = selectedProgram ? selectedProgram.id : '';
    }
    return selectedProgram;
  };
  const getMiniCartSignatureRewardsDraft = (program, customerPoints, branding = {}) => {
    if (!program) {
      return {
        helperMessage: '',
        errorMessage: '',
        previewText: '',
        pointsToRedeem: undefined,
        isValid: false,
        inputValue: '',
        placeholderValue: '100',
        inputMaxValue: ''
      };
    }
    const minimumPoints = Math.max(program.minimumPoints || 0, 0);
    if (!program.isDynamic) {
      return {
        helperMessage: minimumPoints > 0 ? `Requires ${formatMiniCartSignatureRewardsPoints(minimumPoints, branding)}.` : '',
        errorMessage: customerPoints >= minimumPoints ? '' : `You need ${formatMiniCartSignatureRewardsPoints(minimumPoints, branding)}.`,
        previewText: getMiniCartSignatureRewardsPreviewText(program, minimumPoints),
        pointsToRedeem: undefined,
        isValid: customerPoints >= minimumPoints,
        inputValue: '',
        placeholderValue: minimumPoints > 0 ? String(minimumPoints) : '100',
        inputMaxValue: ''
      };
    }
    const maxRedeemablePoints = getMiniCartSignatureRewardsProgramRedeemPointCap(program, customerPoints);
    const sanitizedInput = String(miniCartSignatureRewardsUiState.pointsInput || '').replace(/[^\d]/g, '');
    const hasEnteredPoints = sanitizedInput !== '';
    const parsedPoints = hasEnteredPoints ? parseInt(sanitizedInput, 10) || 0 : 0;
    const helperMessages = [];
    if (minimumPoints > 0) {
      helperMessages.push(`Redeem in increments of ${formatMiniCartSignatureRewardsPoints(minimumPoints, branding)}.`);
    }
    if (maxRedeemablePoints > 0 && customerPoints > maxRedeemablePoints) {
      helperMessages.push(`Max ${formatMiniCartSignatureRewardsPoints(maxRedeemablePoints, branding)} per reward.`);
    }
    let errorMessage = '';
    if (maxRedeemablePoints > 0 && parsedPoints > maxRedeemablePoints) {
      errorMessage = `You can redeem up to ${formatMiniCartSignatureRewardsPoints(maxRedeemablePoints, branding)} at once.`;
    } else if (minimumPoints > 0 && parsedPoints > 0 && parsedPoints < minimumPoints) {
      errorMessage = `Enter at least ${formatMiniCartSignatureRewardsPoints(minimumPoints, branding)}.`;
    } else if (minimumPoints > 0 && parsedPoints > 0 && parsedPoints % minimumPoints !== 0) {
      errorMessage = `Use increments of ${formatMiniCartSignatureRewardsPoints(minimumPoints, branding)}.`;
    }
    const previewPoints = hasEnteredPoints && maxRedeemablePoints > 0
      ? Math.min(parsedPoints, maxRedeemablePoints)
      : (hasEnteredPoints ? parsedPoints : minimumPoints);
    return {
      helperMessage: helperMessages.join(' '),
      errorMessage,
      previewText: getMiniCartSignatureRewardsPreviewText(program, previewPoints),
      pointsToRedeem: hasEnteredPoints ? parsedPoints : undefined,
      isValid: hasEnteredPoints && parsedPoints >= minimumPoints && (!maxRedeemablePoints || parsedPoints <= maxRedeemablePoints) && !errorMessage,
      inputValue: sanitizedInput,
      placeholderValue: minimumPoints > 0 ? String(minimumPoints) : '100',
      inputMaxValue: maxRedeemablePoints > 0 ? String(maxRedeemablePoints) : ''
    };
  };
  const getMiniCartSignatureRewardsAppliedReward = (rewards, cart) => {
    const availableRewards = Array.isArray(rewards) ? rewards : [];
    const cartAppliedReward = getMiniCartSignatureRewardsCartSnapshot(cart);
    const storedRewardSnapshot = getMiniCartSignatureRewardsHydratedReward(
      cartAppliedReward,
      miniCartSignatureRewardsUiState.appliedRewardSnapshot || getMiniCartSignatureRewardsStoredReward()
    );
    const liveAppliedReward = availableRewards.find(reward => {
      return doesMiniCartSignatureRewardMatchCart(reward, cart)
        || doesMiniCartSignatureRewardsRewardMatchStoredReward(reward, cartAppliedReward);
    }) || null;
    if (liveAppliedReward) {
      const hydratedLiveAppliedReward = getMiniCartSignatureRewardsHydratedReward(liveAppliedReward, storedRewardSnapshot);
      persistMiniCartSignatureRewardsAppliedReward(hydratedLiveAppliedReward);
      return hydratedLiveAppliedReward;
    }
    const storedAppliedReward = storedRewardSnapshot;
    if (!storedAppliedReward) {
      return null;
    }
    const matchingStoredReward = availableRewards.find(reward => {
      return doesMiniCartSignatureRewardsRewardMatchStoredReward(reward, storedAppliedReward);
    }) || null;
    const hydratedMatchingStoredReward = matchingStoredReward
      ? getMiniCartSignatureRewardsHydratedReward(matchingStoredReward, storedAppliedReward)
      : null;
    if (matchingStoredReward) {
      persistMiniCartSignatureRewardsAppliedReward(hydratedMatchingStoredReward);
      if (doesMiniCartSignatureRewardsCartHaveDiscount(cart)) {
        return hydratedMatchingStoredReward;
      }
    }
    if (doesMiniCartSignatureRewardsCartHaveDiscount(cart)) {
      return hydratedMatchingStoredReward || storedAppliedReward;
    }
    clearMiniCartSignatureRewardsAppliedReward();
    return null;
  };
  const getMiniCartSignatureRewardsAppliedDiscountApplication = (reward, cart) => {
    if (!reward || !cart) {
      return null;
    }
    const rewardMatches = getMiniCartSignatureRewardsRewardMatchTokens(reward);
    if (!rewardMatches.length) {
      return null;
    }
    const discountApplications = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    const matchedApplication = discountApplications.find(discount => {
      const discountTitle = normalizeMiniCartSignatureRewardsValue(discount && discount.title);
      return discountTitle && rewardMatches.includes(discountTitle);
    }) || discountApplications[0] || null;
    if (matchedApplication) {
      return matchedApplication;
    }
    const totalDiscount = Number(cart && cart.total_discount) || 0;
    if (totalDiscount <= 0) {
      return null;
    }
    return {
      title: getMiniCartSignatureRewardsRewardCode(reward) || getMiniCartSignatureRewardsRewardTitle(reward) || window.PXUTheme.translation.cart_discount_text || 'Discount',
      total_allocated_amount: totalDiscount
    };
  };
  const getMiniCartSignatureRewardsPreservedDiscountTitles = (cart, rewards, additionalJoyCodes = []) => {
    const joyCodes = new Set(
      []
        .concat(additionalJoyCodes || [])
        .concat(Array.isArray(rewards) ? rewards.map(reward => getMiniCartSignatureRewardsRewardCode(reward)) : [])
        .map(normalizeMiniCartSignatureRewardsValue)
        .filter(Boolean)
    );
    return getMiniCartCartLevelDiscountTitles(cart).filter(title => !joyCodes.has(normalizeMiniCartSignatureRewardsValue(title)));
  };
  const fetchMiniCartCartJson = () => new Promise((resolve, reject) => {
    $.ajax({
      url: `${window.Shopify.routes.root}cart.js`,
      dataType: 'json',
      cache: false,
      success: resolve,
      error: reject
    });
  });
  const updateMiniCartCartDiscounts = (discountValue, attributes = null) => new Promise((resolve, reject) => {
    const payload = {
      discount: discountValue
    };
    if (attributes && typeof attributes === 'object') {
      payload.attributes = attributes;
    }
    $.ajax({
      url: `${window.Shopify.routes.root}cart/update.js`,
      dataType: 'json',
      cache: false,
      type: 'post',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(payload),
      success: resolve,
      error: reject
    });
  });
  const getMiniCartSignatureRewardsState = async cart => {
    if (!(window.joyInstance && typeof window.joyInstance.customer === 'function' && typeof window.joyInstance.redeemPrograms === 'function' && typeof window.joyInstance.rewardList === 'function')) {
      throw new Error('Rewards are still loading.');
    }
    const fetchPrograms = () => window.joyInstance.redeemPrograms().catch(() => []);
    const [customer, initialPrograms, rewardsResponse, branding, cartData, tiersResponse] = await Promise.all([
      window.joyInstance.customer(),
      fetchPrograms(),
      window.joyInstance.rewardList({
        before: '',
        after: ''
      }).catch(() => ({ data: [] })),
      typeof window.joyInstance.settingsBranding === 'function'
        ? window.joyInstance.settingsBranding().catch(() => ({}))
        : Promise.resolve({}),
      cart ? Promise.resolve(cart) : fetchMiniCartCartJson(),
      typeof window.joyInstance.tiers === 'function'
        ? window.joyInstance.tiers().catch(() => [])
        : Promise.resolve([])
    ]);
    let normalizedPrograms = normalizeMiniCartSignatureRewardsPrograms(initialPrograms);
    if (!normalizedPrograms.some(program => program.isFreeShipping) && window.joyInstance && typeof window.joyInstance.updateCustomerState === 'function') {
      try {
        const updateResult = window.joyInstance.updateCustomerState();
        if (updateResult && typeof updateResult.then === 'function') {
          await updateResult;
        } else {
          await new Promise(resolve => window.setTimeout(resolve, 180));
        }
        const refreshedPrograms = await fetchPrograms();
        const refreshedNormalizedPrograms = normalizeMiniCartSignatureRewardsPrograms(refreshedPrograms);
        if (
          refreshedNormalizedPrograms.some(program => program.isFreeShipping)
          || didMiniCartSignatureRewardsProgramsChange(normalizedPrograms, refreshedNormalizedPrograms)
        ) {
          normalizedPrograms = refreshedNormalizedPrograms;
        }
      } catch (error) {
        // Keep the first successful program payload if the warm refresh fails.
      }
    }
    let rewards = Array.isArray(rewardsResponse && rewardsResponse.data) ? rewardsResponse.data : [];
    const cartAppliedReward = getMiniCartSignatureRewardsCartSnapshot(cartData);
    const storedAppliedReward = getMiniCartSignatureRewardsHydratedReward(
      cartAppliedReward,
      miniCartSignatureRewardsUiState.appliedRewardSnapshot || getMiniCartSignatureRewardsStoredReward()
    );
    if (storedAppliedReward) {
      const matchingStoredReward = rewards.find(reward => {
        return doesMiniCartSignatureRewardsRewardMatchStoredReward(reward, storedAppliedReward);
      }) || null;
      if (matchingStoredReward) {
        const hydratedMatchingStoredReward = getMiniCartSignatureRewardsHydratedReward(matchingStoredReward, storedAppliedReward);
        persistMiniCartSignatureRewardsAppliedReward(hydratedMatchingStoredReward);
        rewards = rewards.map(reward => reward === matchingStoredReward ? hydratedMatchingStoredReward : reward);
      } else if (doesMiniCartSignatureRewardMatchCart(storedAppliedReward, cartData)) {
        rewards = [storedAppliedReward].concat(rewards);
      } else {
        clearMiniCartSignatureRewardsAppliedReward();
      }
    }
    return {
      customer: customer || {},
      programs: normalizedPrograms,
      rewards,
      tiers: (Array.isArray(tiersResponse) ? tiersResponse : []).map(normalizeMiniCartSignatureRewardsTier),
      currentTier: getMiniCartSignatureRewardsCurrentTier((Array.isArray(tiersResponse) ? tiersResponse : []).map(normalizeMiniCartSignatureRewardsTier)),
      branding: branding || {},
      cart: cartData || {}
    };
  };
  const updateMiniCartSignatureRewardsFormState = () => {
    if (!miniCartSignatureRewardsStateCache) {
      return;
    }
    const availablePrograms = getMiniCartSignatureRewardsAvailablePrograms(miniCartSignatureRewardsStateCache);
    const selectedProgram = getMiniCartSignatureRewardsSelectedProgram(availablePrograms);
    const customerPoints = Number(miniCartSignatureRewardsStateCache.customer && miniCartSignatureRewardsStateCache.customer.point) || 0;
    const draft = getMiniCartSignatureRewardsDraft(selectedProgram, customerPoints, miniCartSignatureRewardsStateCache.branding);
    const $applyButton = $('[data-mini-cart-joy-redeem]').first();
    if ($applyButton.length) {
      $applyButton.attr('data-program-id', selectedProgram ? selectedProgram.id : '');
      if (selectedProgram && selectedProgram.isDynamic && typeof draft.pointsToRedeem === 'number') {
        $applyButton.attr('data-points', draft.pointsToRedeem);
      } else {
        $applyButton.removeAttr('data-points');
      }
      $applyButton.prop('disabled', !(selectedProgram && draft.isValid));
    }
    $('[data-mini-cart-signature-rewards-preview]').text(draft.previewText || '');
    $('[data-mini-cart-signature-rewards-helper]').text(draft.helperMessage || '');
    const $error = $('[data-mini-cart-signature-rewards-error]').first();
    if ($error.length) {
      if (draft.errorMessage) {
        $error.text(draft.errorMessage).removeAttr('hidden');
      } else {
        $error.text('').attr('hidden', true);
      }
    }
  };
  const renderMiniCartSignatureRewards = state => {
    miniCartSignatureRewardsStateCache = state;
    const customerPoints = Number(state && state.customer && state.customer.point) || 0;
    const supportedPrograms = Array.isArray(state && state.programs) ? state.programs : [];
    const availablePrograms = getMiniCartSignatureRewardsAvailablePrograms(state);
    const appliedReward = getMiniCartSignatureRewardsAppliedReward(state.rewards, state.cart);
    const hasRedeemablePrograms = availablePrograms.length > 0;
    const selectedProgram = getMiniCartSignatureRewardsSelectedProgram(availablePrograms);
    const draft = getMiniCartSignatureRewardsDraft(selectedProgram, customerPoints, state.branding);
    const toggleDisabled = !appliedReward && !hasRedeemablePrograms;
    const toggleLabel = appliedReward ? 'Manage Reward' : 'Redeem Gems';
    const rewardsButtonStyle = getMiniCartSignatureRewardsButtonStyle();
    let markup = '<div class="mini-cart__rewards-summary">';
    markup += `<div class="mini-cart__rewards-summary-copy"><p class="mini-cart__rewards-label">You have</p><p class="mini-cart__rewards-value">${miniCartEscapeHtml(formatMiniCartSignatureRewardsPoints(customerPoints, state.branding))}</p></div>`;
    markup += `<button type="button" class="global-button ${miniCartEscapeHtml(rewardsButtonStyle)} mini-cart__rewards-toggle" data-mini-cart-signature-rewards-toggle aria-expanded="${miniCartSignatureRewardsUiState.expanded ? 'true' : 'false'}"${toggleDisabled ? ' disabled' : ''}>${miniCartEscapeHtml(toggleLabel)}</button>`;
    markup += '</div>';
    if (miniCartSignatureRewardsUiState.expanded) {
      markup += '<div class="mini-cart__rewards-divider"></div>';
      if (appliedReward) {
        const appliedTitle = String(getMiniCartSignatureRewardsRewardTitle(appliedReward) || getMiniCartSignatureRewardsRewardCode(appliedReward) || 'Reward applied').trim();
        const rewardId = getMiniCartSignatureRewardsRewardId(appliedReward);
        const couponCode = getMiniCartSignatureRewardsRewardCode(appliedReward);
        const appliedDiscount = getMiniCartSignatureRewardsAppliedDiscountApplication(appliedReward, state.cart);
        const appliedDiscountAmount = Number(appliedDiscount && appliedDiscount.total_allocated_amount) || 0;
        markup += '<div class="mini-cart__rewards-applied">';
        markup += '<p class="mini-cart__rewards-applied-label">Reward applied</p>';
        markup += `<p class="mini-cart__rewards-applied-title">${miniCartEscapeHtml(appliedTitle)}</p>`;
        if (couponCode) {
          markup += '<div class="mini-cart__rewards-code-row">';
          markup += `<span class="mini-cart__rewards-code">${miniCartEscapeHtml(couponCode)}</span>`;
          markup += '<div class="mini-cart__rewards-code-meta">';
          if (appliedDiscountAmount > 0) {
            markup += `<span class="mini-cart__rewards-code-amount">-${miniCartEscapeHtml(formatMiniCartMoney(appliedDiscountAmount))}</span>`;
          }
          markup += `<button type="button" class="mini-cart__rewards-code-remove" aria-label="Remove reward and return your Gems" data-mini-cart-joy-revoke data-reward-id="${miniCartEscapeHtml(rewardId)}" data-coupon-code="${miniCartEscapeHtml(couponCode)}">${getMiniCartSignatureRewardsUndoIconMarkup()}</button>`;
          markup += '</div>';
          markup += '</div>';
        } else {
          markup += `<button type="button" class="mini-cart__rewards-text-button" data-mini-cart-joy-revoke data-reward-id="${miniCartEscapeHtml(rewardId)}" data-coupon-code="${miniCartEscapeHtml(couponCode)}">Remove reward</button>`;
        }
        markup += '<p class="mini-cart__rewards-helper mini-cart__rewards-helper--below">Remove this code to return your Gems.</p>';
        markup += '</div>';
      } else if (hasRedeemablePrograms && selectedProgram) {
        markup += '<div class="mini-cart__rewards-form">';
        markup += '<label class="mini-cart__rewards-field-label" for="MiniCartRewardsProgram">Choose a Reward</label>';
        markup += '<div class="mini-cart__rewards-select-wrap">';
        markup += '<select id="MiniCartRewardsProgram" class="mini-cart__rewards-select" data-mini-cart-joy-program-select>';
        availablePrograms.forEach(program => {
          markup += `<option value="${miniCartEscapeHtml(program.id)}"${program.id === selectedProgram.id ? ' selected' : ''}>${miniCartEscapeHtml(program.title)}</option>`;
        });
        markup += '</select>';
        markup += '</div>';
        if (selectedProgram.isDynamic) {
          markup += '<label class="mini-cart__rewards-field-label" for="MiniCartRewardsPoints">Gems</label>';
          markup += `<p class="mini-cart__rewards-helper" data-mini-cart-signature-rewards-helper>${miniCartEscapeHtml(draft.helperMessage || '')}</p>`;
          markup += '<div class="mini-cart__rewards-dynamic-row">';
          markup += '<div class="mini-cart__rewards-field mini-cart__rewards-field--compact">';
          markup += `<input id="MiniCartRewardsPoints" class="mini-cart__rewards-input" type="number" min="0" inputmode="numeric" step="${Math.max(selectedProgram.minimumPoints || 1, 1)}" max="${miniCartEscapeHtml(draft.inputMaxValue || customerPoints)}" value="${miniCartEscapeHtml(draft.inputValue || '')}" placeholder="${miniCartEscapeHtml(draft.placeholderValue || '100')}" data-mini-cart-joy-points-input />`;
          markup += '</div>';
          markup += '<div class="mini-cart__rewards-preview-card mini-cart__rewards-preview-card--plain">';
          markup += `<p class="mini-cart__rewards-preview" data-mini-cart-signature-rewards-preview>${miniCartEscapeHtml(draft.previewText || '')}</p>`;
          markup += '</div>';
          markup += '</div>';
        } else {
          const previewDetailText = getMiniCartSignatureRewardsPreviewDetailText(selectedProgram);
          markup += '<div class="mini-cart__rewards-preview-card mini-cart__rewards-preview-card--plain mini-cart__rewards-preview-card--full">';
          markup += `<p class="mini-cart__rewards-preview" data-mini-cart-signature-rewards-preview>${miniCartEscapeHtml(draft.previewText || '')}</p>`;
          if (previewDetailText) {
            markup += `<p class="mini-cart__rewards-helper">${miniCartEscapeHtml(previewDetailText)}</p>`;
          }
          markup += '</div>';
          markup += `<p class="mini-cart__rewards-helper mini-cart__rewards-helper--below" data-mini-cart-signature-rewards-helper>${miniCartEscapeHtml(draft.helperMessage || '')}</p>`;
        }
        markup += `<p class="mini-cart__rewards-error" data-mini-cart-signature-rewards-error${draft.errorMessage ? '' : ' hidden'}>${miniCartEscapeHtml(draft.errorMessage || '')}</p>`;
        markup += `<button type="button" class="global-button ${miniCartEscapeHtml(rewardsButtonStyle)} mini-cart__rewards-apply" data-mini-cart-joy-redeem data-program-id="${miniCartEscapeHtml(selectedProgram.id)}"${selectedProgram.isDynamic && typeof draft.pointsToRedeem === 'number' ? ` data-points="${draft.pointsToRedeem}"` : ''}${draft.isValid ? '' : ' disabled'}>Apply</button>`;
        markup += '<button type="button" class="mini-cart__rewards-text-button mini-cart__rewards-cancel" data-mini-cart-signature-rewards-cancel>Cancel</button>';
        markup += '</div>';
      } else if (supportedPrograms.length) {
        markup += '<p class="mini-cart__rewards-note meta">Keep shopping to unlock a reward you can use in your bag.</p>';
      } else {
        markup += '<p class="mini-cart__rewards-note meta">No cart-friendly rewards are available right now.</p>';
      }
    }
    renderMiniCartSignatureRewardsMarkup(markup);
    updateMiniCartSignatureRewardsFormState();
  };
  const renderMiniCartSignatureRewardsLoading = message => {
    miniCartSignatureRewardsStateCache = null;
    renderMiniCartSignatureRewardsMarkup(`<p class="mini-cart__rewards-note meta">${miniCartEscapeHtml(message || 'Loading your rewards...')}</p>`);
  };
  const renderMiniCartSignatureRewardsError = message => {
    miniCartSignatureRewardsStateCache = null;
    renderMiniCartSignatureRewardsMarkup(`<p class="mini-cart__rewards-note meta">${miniCartEscapeHtml(message || 'We could not load your rewards right now.')}</p>`);
  };
  const updateMiniCartSignatureRewardsFeaturedFormState = () => {
    if (!miniCartSignatureRewardsStateCache) {
      return;
    }
    const context = getMiniCartSignatureRewardsFeaturedContext(miniCartSignatureRewardsStateCache);
    const { selectedProgram, dynamicState, appliedReward } = context;
    const hasAppliedReward = !!appliedReward;
    $('[data-mini-cart-signature-rewards-featured-option]').each(function () {
      const $option = $(this);
      const isSelected = String($option.data('programId') || '') === String(selectedProgram && selectedProgram.id ? selectedProgram.id : '');
      $option
        .toggleClass('is-selected', isSelected)
        .attr('aria-checked', isSelected ? 'true' : 'false')
        .attr('aria-disabled', hasAppliedReward ? 'true' : 'false');
      if ($option.is('button')) {
        $option.prop('disabled', hasAppliedReward);
      }
    });
    $('[data-mini-cart-signature-rewards-featured-apply]').each(function () {
      const $button = $(this);
      $button.attr('data-program-id', selectedProgram ? selectedProgram.id : '');
      if (selectedProgram && selectedProgram.isDynamic && dynamicState) {
        $button.attr('data-points', dynamicState.value);
      } else {
        $button.removeAttr('data-points');
      }
      const hasRedeemableDynamicValue = !(selectedProgram && selectedProgram.isDynamic) || (dynamicState && dynamicState.value > 0);
      $button
        .prop('disabled', !selectedProgram || hasAppliedReward || !hasRedeemableDynamicValue)
        .text(hasAppliedReward ? 'Reward Applied' : 'Apply Selected Reward');
    });
    $('[data-mini-cart-signature-rewards-featured-adjust]').prop('disabled', hasAppliedReward);
    $('[data-mini-cart-signature-rewards-featured-range]').each(function () {
      const $input = $(this);
      $input.prop('disabled', hasAppliedReward);
      if (selectedProgram && selectedProgram.isDynamic && dynamicState) {
        const progress = dynamicState.max > dynamicState.min
          ? ((dynamicState.value - dynamicState.min) / (dynamicState.max - dynamicState.min)) * 100
          : 100;
        $input
          .attr('min', dynamicState.min)
          .attr('max', dynamicState.max)
          .attr('step', dynamicState.step)
          .val(dynamicState.value)
          .css('--mini-cart-rewards-featured-range-progress', `${progress}%`);
      }
    });
    $('[data-mini-cart-signature-rewards-featured-points]').text(
      dynamicState
        ? dynamicState.value.toLocaleString()
        : ''
    );
    $('[data-mini-cart-signature-rewards-featured-preview]').text(
      dynamicState
        ? formatMiniCartSignatureRewardsSavingsCurrency(dynamicState.saveAmount)
        : ''
    );
    $('[data-mini-cart-signature-rewards-featured-step]').text(
      dynamicState
        ? formatMiniCartSignatureRewardsPoints(dynamicState.step, miniCartSignatureRewardsStateCache.branding)
        : ''
    );
  };
  const renderMiniCartSignatureRewardsFeatured = state => {
    miniCartSignatureRewardsStateCache = state;
    const icons = getMiniCartSignatureRewardsFeaturedIcons();
    const heading = getMiniCartSignatureRewardsFeaturedHeading();
    const currentTierName = formatMiniCartSignatureRewardsTitle((state && state.currentTier && state.currentTier.name) || getMiniCartSignatureRewardsTierName() || (state && state.customer && state.customer.type) || 'Member');
    const badgeUrl = String((state && state.currentTier && state.currentTier.badgeUrl) || getMiniCartSignatureRewardsFeaturedFallbackBadgeUrl(currentTierName) || '').trim();
    const context = getMiniCartSignatureRewardsFeaturedContext(state);
    const {
      customerPoints,
      dynamicProgram,
      shippingProgram,
      rewardOptions,
      appliedReward,
      selectedProgram,
      dynamicState,
      hasRedeemablePrograms
    } = context;
    const balanceText = formatMiniCartSignatureRewardsPoints(customerPoints, state.branding);
    const shippingIconMarkup = shippingProgram
      ? getMiniCartSignatureRewardsProgramIconMarkup(shippingProgram, icons.truck)
      : icons.truck;
    const featuredButtonStyle = getMiniCartSignatureRewardsFeaturedButtonStyle();
    const hasRewardSelection = hasRedeemablePrograms && rewardOptions.length;
    let markup = '<div class="mini-cart__rewards-featured-shell">';
    markup += '<div class="mini-cart__rewards-featured-header">';
    markup += `<div class="mini-cart__rewards-featured-brand${badgeUrl ? '' : ' mini-cart__rewards-featured-brand--no-badge'}">`;
    if (badgeUrl) {
      markup += '<div class="mini-cart__rewards-featured-badge">';
      markup += `<img src="${miniCartEscapeHtml(badgeUrl)}" alt="${miniCartEscapeHtml(currentTierName)} badge" loading="lazy">`;
      markup += '</div>';
    }
    markup += `<div class="mini-cart__rewards-featured-title-group"><h3 class="mini-cart__block-heading">${miniCartEscapeHtml(heading)}</h3><p class="mini-cart__rewards-featured-tier">${miniCartEscapeHtml(currentTierName)}</p></div>`;
    markup += '</div>';
    markup += '<div class="mini-cart__rewards-featured-balance">';
    markup += '<p class="mini-cart__rewards-label">Your balance</p>';
    markup += `<p class="mini-cart__rewards-featured-balance-value"><span class="mini-cart__rewards-featured-balance-icon" aria-hidden="true">${icons.balanceGem}</span><span>${miniCartEscapeHtml(balanceText)}</span></p>`;
    markup += '</div>';
    markup += '</div>';
    markup += '<div class="mini-cart__rewards-featured-body">';
    if (hasRewardSelection) {
      markup += '<p class="mini-cart__rewards-featured-section-title">Choose a Reward</p>';
      markup += '<div class="mini-cart__rewards-featured-options">';
      if (shippingProgram) {
        markup += `<button type="button" class="mini-cart__rewards-featured-option mini-cart__rewards-featured-option--button${selectedProgram && selectedProgram.id === shippingProgram.id ? ' is-selected' : ''}" role="radio" tabindex="0" aria-checked="${selectedProgram && selectedProgram.id === shippingProgram.id ? 'true' : 'false'}" aria-disabled="${appliedReward ? 'true' : 'false'}" data-mini-cart-signature-rewards-featured-option data-mini-cart-signature-rewards-featured-select data-program-id="${miniCartEscapeHtml(shippingProgram.id)}"${appliedReward ? ' disabled' : ''}>`;
        markup += `<span class="mini-cart__rewards-featured-option-icon" aria-hidden="true">${shippingIconMarkup}</span>`;
        markup += '<span class="mini-cart__rewards-featured-option-copy">';
        markup += '<span class="mini-cart__rewards-featured-option-title">Free Standard U.S. Shipping</span>';
        markup += `<span class="mini-cart__rewards-featured-option-meta">${miniCartEscapeHtml(formatMiniCartSignatureRewardsPoints(shippingProgram.minimumPoints, state.branding))}</span>`;
        markup += '</span>';
        markup += '<span class="mini-cart__rewards-featured-radio" aria-hidden="true"></span>';
        markup += '</button>';
      }
      if (dynamicProgram && dynamicState) {
        markup += `<div class="mini-cart__rewards-featured-option mini-cart__rewards-featured-option--dynamic${selectedProgram && selectedProgram.id === dynamicProgram.id ? ' is-selected' : ''}" role="radio" tabindex="0" aria-checked="${selectedProgram && selectedProgram.id === dynamicProgram.id ? 'true' : 'false'}" aria-disabled="${appliedReward ? 'true' : 'false'}" data-mini-cart-signature-rewards-featured-option data-mini-cart-signature-rewards-featured-select data-program-id="${miniCartEscapeHtml(dynamicProgram.id)}">`;
        markup += '<div class="mini-cart__rewards-featured-option-main">';
        markup += `<span class="mini-cart__rewards-featured-option-icon mini-cart__rewards-featured-option-icon--gem" aria-hidden="true">${icons.shopGem}</span>`;
        markup += '<span class="mini-cart__rewards-featured-option-copy">';
        markup += '<span class="mini-cart__rewards-featured-option-title">Shop with Gems</span>';
        markup += `<span class="mini-cart__rewards-featured-option-meta">Rule: ${miniCartEscapeHtml(formatMiniCartSignatureRewardsPoints(dynamicState.step, state.branding))} = ${miniCartEscapeHtml(formatMiniCartSignatureRewardsCurrency(dynamicProgram.rewardAmount || 0))} off.</span>`;
        markup += '</span>';
        markup += '<span class="mini-cart__rewards-featured-radio" aria-hidden="true"></span>';
        markup += '</div>';
        markup += '<div class="mini-cart__rewards-featured-slider-row">';
        markup += '<div class="mini-cart__rewards-featured-slider-area">';
        markup += '<p class="mini-cart__rewards-featured-slider-label">Redeem <span data-mini-cart-signature-rewards-featured-points>' + miniCartEscapeHtml(dynamicState.value.toLocaleString()) + '</span> for <span data-mini-cart-signature-rewards-featured-preview>' + miniCartEscapeHtml(formatMiniCartSignatureRewardsSavingsCurrency(dynamicState.saveAmount)) + '</span> off</p>';
        markup += '<div class="mini-cart__rewards-featured-slider-controls">';
        markup += '<button type="button" class="mini-cart__rewards-featured-stepper" data-mini-cart-signature-rewards-featured-adjust="-1" data-program-id="' + miniCartEscapeHtml(dynamicProgram.id) + '"' + (appliedReward ? ' disabled' : '') + '>' + icons.minus + '</button>';
        markup += `<input class="mini-cart__rewards-featured-range" type="range" min="${dynamicState.min}" max="${dynamicState.max}" step="${dynamicState.step}" value="${dynamicState.value}" data-mini-cart-signature-rewards-featured-range data-program-id="${miniCartEscapeHtml(dynamicProgram.id)}"${appliedReward ? ' disabled' : ''} />`;
        markup += '<button type="button" class="mini-cart__rewards-featured-stepper" data-mini-cart-signature-rewards-featured-adjust="1" data-program-id="' + miniCartEscapeHtml(dynamicProgram.id) + '"' + (appliedReward ? ' disabled' : '') + '>' + icons.plus + '</button>';
        markup += '</div>';
        if (dynamicState.isCapped) {
          markup += `<p class="mini-cart__rewards-featured-slider-meta">Max ${miniCartEscapeHtml(formatMiniCartSignatureRewardsPoints(dynamicState.max, state.branding))} per reward.</p>`;
        }
        markup += '</div>';
        markup += '</div>';
        markup += '</div>';
      }
      markup += '</div>';
      markup += '<div class="mini-cart__rewards-featured-actions">';
      const canApplySelectedReward = selectedProgram && !appliedReward && (!(selectedProgram.isDynamic) || (dynamicState && dynamicState.value > 0));
      markup += `<button type="button" class="global-button ${miniCartEscapeHtml(featuredButtonStyle)} mini-cart__rewards-featured-apply" data-mini-cart-signature-rewards-featured-apply data-program-id="${miniCartEscapeHtml(selectedProgram ? selectedProgram.id : '')}"${selectedProgram && selectedProgram.isDynamic && dynamicState ? ` data-points="${dynamicState.value}"` : ''}${canApplySelectedReward ? '' : ' disabled'}>${miniCartEscapeHtml(appliedReward ? 'Reward Applied' : 'Apply Selected Reward')}</button>`;
      if (!appliedReward) {
        markup += '<button type="button" class="mini-cart__rewards-text-button mini-cart__rewards-featured-cancel" data-mini-cart-signature-rewards-featured-cancel>Cancel</button>';
      }
      markup += '</div>';
    }
    if (appliedReward) {
      const appliedTitle = String(getMiniCartSignatureRewardsRewardTitle(appliedReward) || getMiniCartSignatureRewardsRewardCode(appliedReward) || 'Reward applied').trim();
      const rewardId = getMiniCartSignatureRewardsRewardId(appliedReward);
      const couponCode = getMiniCartSignatureRewardsRewardCode(appliedReward);
      const appliedDiscount = getMiniCartSignatureRewardsAppliedDiscountApplication(appliedReward, state.cart);
      const appliedDiscountAmount = Number(appliedDiscount && appliedDiscount.total_allocated_amount) || 0;
      markup += '<div class="mini-cart__rewards-featured-applied">';
      markup += '<div class="mini-cart__rewards-featured-note">';
      markup += `<p class="mini-cart__rewards-featured-section-title">Reward applied</p>`;
      markup += `<p class="mini-cart__rewards-featured-note-copy">${miniCartEscapeHtml(appliedTitle)} is already active on this bag. Remove it below to choose a different reward.</p>`;
      markup += '</div>';
      if (couponCode) {
        markup += '<div class="mini-cart__rewards-code-row mini-cart__rewards-code-row--featured">';
        markup += `<span class="mini-cart__rewards-code">${miniCartEscapeHtml(couponCode)}</span>`;
        markup += '<div class="mini-cart__rewards-code-meta">';
        if (appliedDiscountAmount > 0) {
          markup += `<span class="mini-cart__rewards-code-amount">-${miniCartEscapeHtml(formatMiniCartMoney(appliedDiscountAmount))}</span>`;
        }
        markup += `<button type="button" class="mini-cart__rewards-code-remove" aria-label="Remove reward and return your Gems" data-mini-cart-joy-revoke data-reward-id="${miniCartEscapeHtml(rewardId)}" data-coupon-code="${miniCartEscapeHtml(couponCode)}">${getMiniCartSignatureRewardsUndoIconMarkup()}</button>`;
        markup += '</div>';
        markup += '</div>';
      } else {
        markup += `<button type="button" class="mini-cart__rewards-text-button" data-mini-cart-joy-revoke data-reward-id="${miniCartEscapeHtml(rewardId)}" data-coupon-code="${miniCartEscapeHtml(couponCode)}">Remove reward</button>`;
      }
      markup += '</div>';
    } else if (!hasRewardSelection) {
      markup += '<p class="mini-cart__rewards-note meta">No cart-friendly rewards are available right now.</p>';
    }
    markup += '</div>';
    markup += '</div>';
    renderMiniCartSignatureRewardsFeaturedMarkup(markup);
    updateMiniCartSignatureRewardsFeaturedFormState();
  };
  const renderMiniCartSignatureRewardsFeaturedLoading = message => {
    renderMiniCartSignatureRewardsFeaturedMarkup(`<p class="mini-cart__rewards-note meta">${miniCartEscapeHtml(message || 'Loading your rewards...')}</p>`);
  };
  const renderMiniCartSignatureRewardsFeaturedError = message => {
    renderMiniCartSignatureRewardsFeaturedMarkup(`<p class="mini-cart__rewards-note meta">${miniCartEscapeHtml(message || 'We could not load your rewards right now.')}</p>`);
  };
  const resetMiniCartSignatureRewardsShippingRefresh = () => {
    clearTimeout(miniCartSignatureRewardsShippingRefreshTimer);
    miniCartSignatureRewardsShippingRefreshTimer = null;
    miniCartSignatureRewardsShippingRefreshAttempt = 0;
  };
  const scheduleMiniCartSignatureRewardsShippingRefresh = state => {
    const customerPoints = Number(state && state.customer && state.customer.point) || 0;
    const hasAppliedReward = !!getMiniCartSignatureRewardsAppliedReward(state && state.rewards, state && state.cart);
    const hasShippingProgram = !!getMiniCartSignatureRewardsFeaturedPrograms(state).shippingProgram;
    const shouldRetry = getMiniCartSignatureRewardsFeaturedBlocks().length
      && customerPoints > 0
      && !hasAppliedReward
      && !hasShippingProgram;
    if (!shouldRetry) {
      resetMiniCartSignatureRewardsShippingRefresh();
      return;
    }
    if (miniCartSignatureRewardsShippingRefreshAttempt >= miniCartSignatureRewardsShippingRefreshDelays.length) {
      return;
    }
    clearTimeout(miniCartSignatureRewardsShippingRefreshTimer);
    const nextDelay = miniCartSignatureRewardsShippingRefreshDelays[miniCartSignatureRewardsShippingRefreshAttempt];
    miniCartSignatureRewardsShippingRefreshAttempt += 1;
    miniCartSignatureRewardsShippingRefreshTimer = window.setTimeout(() => {
      refreshMiniCartSignatureRewards({ delay: 0 });
    }, nextDelay);
  };
  const refreshMiniCartSignatureRewards = ({ delay = 120, cart = null } = {}) => {
    if (!(getMiniCartSignatureRewardsBlocks().length || getMiniCartSignatureRewardsFeaturedBlocks().length)) {
      resetMiniCartSignatureRewardsShippingRefresh();
      return;
    }
    clearTimeout(miniCartSignatureRewardsRefreshTimer);
    miniCartSignatureRewardsRefreshTimer = window.setTimeout(async () => {
      const requestToken = ++miniCartSignatureRewardsRequestToken;
      const blocksByVariant = [
        {
          blocks: getMiniCartSignatureRewardsBlocks(),
          getHost: getMiniCartSignatureRewardsMarkupHost,
          renderLoading: renderMiniCartSignatureRewardsLoading,
          render: renderMiniCartSignatureRewards,
          renderError: renderMiniCartSignatureRewardsError
        },
        {
          blocks: getMiniCartSignatureRewardsFeaturedBlocks(),
          getHost: getMiniCartSignatureRewardsFeaturedMarkupHost,
          renderLoading: renderMiniCartSignatureRewardsFeaturedLoading,
          render: renderMiniCartSignatureRewardsFeatured,
          renderError: renderMiniCartSignatureRewardsFeaturedError
        }
      ];
      blocksByVariant.forEach(variant => {
        if (!variant.blocks.length) {
          return;
        }
        const hasExistingMarkup = variant.blocks.some(block => {
          const markupHost = variant.getHost(block);
          return !!(markupHost && markupHost.textContent.trim().length);
        });
        if (!hasExistingMarkup) {
          variant.renderLoading('Loading your rewards...');
        }
      });
      try {
        const state = await getMiniCartSignatureRewardsState(cart);
        if (requestToken !== miniCartSignatureRewardsRequestToken) {
          return;
        }
        renderMiniCartSummary(state.cart);
        blocksByVariant.forEach(variant => {
          if (variant.blocks.length) {
            variant.render(state);
          }
        });
        scheduleMiniCartSignatureRewardsShippingRefresh(state);
      } catch (error) {
        if (requestToken !== miniCartSignatureRewardsRequestToken) {
          return;
        }
        blocksByVariant.forEach(variant => {
          if (variant.blocks.length) {
            variant.renderError(getMiniCartSignatureRewardsErrorMessage(error, 'We could not load your rewards right now.'));
          }
        });
      }
    }, delay);
  };
  const applyMiniCartSignatureRewardsProgram = async (programId, pointsRequired) => {
    if (!(window.joyInstance && typeof window.joyInstance.redeem === 'function')) {
      throw new Error('Rewards are still loading.');
    }
    const currentState = await getMiniCartSignatureRewardsState();
    if (getMiniCartSignatureRewardsAppliedReward(currentState.rewards, currentState.cart)) {
      throw new Error('Remove your current reward before applying a different one.');
    }
    const selectedProgram = (Array.isArray(currentState.programs) ? currentState.programs : []).find(program => program.id === programId) || null;
    if (selectedProgram && selectedProgram.isDynamic) {
      const minimumPoints = Math.max(selectedProgram.minimumPoints || 0, 0);
      const customerPoints = Number(currentState.customer && currentState.customer.point) || 0;
      const maxRedeemablePoints = getMiniCartSignatureRewardsProgramRedeemPointCap(selectedProgram, customerPoints);
      if (!(typeof pointsRequired === 'number' && !Number.isNaN(pointsRequired) && pointsRequired > 0)) {
        throw new Error('Enter the number of Gems you want to redeem.');
      }
      if (maxRedeemablePoints > 0 && pointsRequired > maxRedeemablePoints) {
        throw new Error(`You can redeem up to ${formatMiniCartSignatureRewardsPoints(maxRedeemablePoints, currentState.branding)} at once.`);
      }
      if (minimumPoints > 0 && pointsRequired < minimumPoints) {
        throw new Error(`Enter at least ${formatMiniCartSignatureRewardsPoints(minimumPoints, currentState.branding)}.`);
      }
      if (minimumPoints > 0 && pointsRequired % minimumPoints !== 0) {
        throw new Error(`Use increments of ${formatMiniCartSignatureRewardsPoints(minimumPoints, currentState.branding)}.`);
      }
    }
    const redemptionResponse = typeof pointsRequired === 'number' && !Number.isNaN(pointsRequired) && pointsRequired > 0
      ? await window.joyInstance.redeem(programId, pointsRequired)
      : await window.joyInstance.redeem(programId);
    const discountCode = String(redemptionResponse && redemptionResponse.discount && redemptionResponse.discount.code ? redemptionResponse.discount.code : '').trim();
    if (!discountCode) {
      throw new Error('Joy did not return a coupon code for this reward.');
    }
    const appliedRewardSnapshot = {
      id: '',
      programId,
      programTitle: selectedProgram ? selectedProgram.title : '',
      couponCode: discountCode
    };
    persistMiniCartSignatureRewardsAppliedReward(appliedRewardSnapshot);
    const preservedDiscountTitles = getMiniCartSignatureRewardsPreservedDiscountTitles(currentState.cart, currentState.rewards, [discountCode]);
    const nextDiscountValue = preservedDiscountTitles.concat(discountCode).filter(Boolean).join(',');
    return updateMiniCartCartDiscounts(
      nextDiscountValue,
      mergeMiniCartCartAttributes(currentState.cart, getMiniCartSignatureRewardsCartAttributesPayload(appliedRewardSnapshot))
    );
  };
  const revokeMiniCartSignatureReward = async (rewardId, couponCode) => {
    if (!(window.joyInstance && typeof window.joyInstance.revokeCoupon === 'function')) {
      throw new Error('Rewards are still loading.');
    }
    const currentState = await getMiniCartSignatureRewardsState();
    let resolvedRewardId = rewardId;
    if (!resolvedRewardId && couponCode) {
      const matchingReward = (Array.isArray(currentState.rewards) ? currentState.rewards : []).find(reward => {
        return normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardCode(reward)) === normalizeMiniCartSignatureRewardsValue(couponCode);
      }) || null;
      resolvedRewardId = getMiniCartSignatureRewardsRewardId(matchingReward);
    }
    if (!resolvedRewardId && couponCode && window.joyInstance && typeof window.joyInstance.rewardList === 'function') {
      for (let attempt = 0; attempt < 3 && !resolvedRewardId; attempt += 1) {
        if (attempt > 0) {
          await new Promise(resolve => window.setTimeout(resolve, 250));
        }
        const rewardListResponse = await window.joyInstance.rewardList({
          before: '',
          after: ''
        }).catch(() => ({ data: [] }));
        const rewardList = Array.isArray(rewardListResponse && rewardListResponse.data) ? rewardListResponse.data : [];
        const matchingReward = rewardList.find(reward => {
          return normalizeMiniCartSignatureRewardsValue(getMiniCartSignatureRewardsRewardCode(reward)) === normalizeMiniCartSignatureRewardsValue(couponCode);
        }) || null;
        resolvedRewardId = getMiniCartSignatureRewardsRewardId(matchingReward);
      }
    }
    if (resolvedRewardId) {
      await window.joyInstance.revokeCoupon(resolvedRewardId);
    }
    const preservedDiscountTitles = getMiniCartSignatureRewardsPreservedDiscountTitles(currentState.cart, currentState.rewards, [couponCode]);
    const updatedCart = await updateMiniCartCartDiscounts(
      preservedDiscountTitles.filter(Boolean).join(','),
      mergeMiniCartCartAttributes(currentState.cart, getMiniCartSignatureRewardsClearedCartAttributesPayload())
    );
    clearMiniCartSignatureRewardsAppliedReward();
    return updatedCart;
  };
  const handleMiniCartSignatureRewardsRevokeButton = async button => {
    const $button = $(button);
    if (!$button.length || $button.prop('disabled') || $button.attr('aria-busy') === 'true') {
      return;
    }
    const rewardId = String($button.data('rewardId') || '').trim();
    const couponCode = String($button.data('couponCode') || '').trim();
    miniCartSignatureRewardsUiState.expanded = true;
    $button.prop('disabled', true).attr('aria-busy', 'true');
    renderMiniCartSignatureRewardsLoading('Removing your reward...');
    renderMiniCartSignatureRewardsFeaturedLoading('Removing your reward...');
    try {
      const updatedCart = await revokeMiniCartSignatureReward(rewardId, couponCode);
      if (window.joyInstance && typeof window.joyInstance.updateCustomerState === 'function') {
        window.joyInstance.updateCustomerState();
      }
      refreshCart(updatedCart);
      refreshMiniCartSignatureRewards({ delay: 200, cart: updatedCart });
    } catch (error) {
      const errorMessage = getMiniCartSignatureRewardsErrorMessage(error, 'We could not remove that reward right now.');
      renderMiniCartSignatureRewardsError(errorMessage);
      renderMiniCartSignatureRewardsFeaturedError(errorMessage);
      refreshMiniCartSignatureRewards({ delay: 800 });
    } finally {
      $button.prop('disabled', false).removeAttr('aria-busy');
    }
  };
  const remountMiniCartJoyInlineBlocks = () => {
    getMiniCartJoyInlineBlocks().forEach(block => {
      if (block.children.length || block.textContent.trim().length) {
        return;
      }
      const replacement = document.createElement('div');
      Array.from(block.attributes).forEach(attribute => {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      replacement.className = block.className;
      block.replaceWith(replacement);
    });
  };
  const refreshMiniCartJoyInline = ({ forceRemount = false, delay = 120 } = {}) => {
    clearTimeout(miniCartJoyRefreshTimer);
    miniCartJoyRefreshTimer = window.setTimeout(() => {
      if (forceRemount) {
        remountMiniCartJoyInlineBlocks();
      }
      resetMiniCartSignatureRewardsShippingRefresh();
      if (window.joyInstance && typeof window.joyInstance.updateCustomerState === 'function') {
        window.joyInstance.updateCustomerState();
      }
      refreshMiniCartSignatureRewards({ delay: 0 });
    }, delay);
  };
  const syncMiniCartCartFromJoy = () => {
    if (!(window.jQuery && window.Shopify && window.Shopify.routes && window.Shopify.routes.root)) {
      return;
    }
    clearTimeout(miniCartJoyCartSyncTimer);
    miniCartJoyCartSyncTimer = window.setTimeout(() => {
      $.getJSON(`${window.Shopify.routes.root}cart.js`, cart => {
        refreshCart(cart);
        refreshMiniCartJoyInline({ delay: 150 });
        refreshMiniCartSignatureRewards({ delay: 0, cart });
      });
    }, 150);
  };
  const setMiniCartEditorPreviewState = active => {
    window.PXUTheme = window.PXUTheme || {};
    window.PXUTheme.miniCartEditorLocked = !!active;

    const miniCartDrawer = document.getElementById('mini-cart-drawer');
    if (!miniCartDrawer) {
      return;
    }

    miniCartDrawer.classList.toggle('active_link', !!active);
    miniCartDrawer.classList.toggle('is-theme-editor-preview', !!active);
    document.documentElement.classList.toggle('mini-cart-editor-active', !!active);
    syncMiniCartGoogleWidgetState();
    if (active) {
      refreshMiniCartJoyInline({ forceRemount: true, delay: 150 });
    }

    if (!active) {
      document.querySelectorAll('.cart-container.active_link').forEach(container => {
        container.classList.remove('active_link');
      });
    }
  };

  const initMiniCartRecommendationSliders = () => {
    if (!(window.jQuery && window.Flickity)) {
      return;
    }

    const equalizeMiniCartRecommendationCardHeights = sliderNode => {
      if (!sliderNode) {
        return;
      }
      const cards = Array.from(sliderNode.querySelectorAll('[data-mini-cart-recommendation-slide]'));
      if (!cards.length) {
        return;
      }
      cards.forEach(card => {
        card.style.minHeight = '';
      });
      window.requestAnimationFrame(() => {
        let tallestCardHeight = 0;
        cards.forEach(card => {
          tallestCardHeight = Math.max(tallestCardHeight, Math.ceil(card.getBoundingClientRect().height || 0));
        });
        if (!tallestCardHeight) {
          return;
        }
        cards.forEach(card => {
          card.style.minHeight = `${tallestCardHeight}px`;
        });
      });
    };

    $('#mini-cart-drawer [data-mini-cart-recommendations-slider]').each((_, sliderEl) => {
      const $slider = $(sliderEl);
      const $block = $slider.closest('.mini-cart__block--recommendations');
      const $dotsHost = $block.find('[data-mini-cart-recommendations-dots]').first();
      const slideCount = $slider.find('[data-mini-cart-recommendation-slide]').length;
      const requestedVisibleCards = parseInt(sliderEl.dataset.visibleCards || '', 10) || 1;
      const visibleCards = Math.max(1, Math.min(slideCount || 1, requestedVisibleCards));
      const previousVisibleCards = parseInt(sliderEl.dataset.flickityVisibleCards || '', 10) || 0;

      sliderEl.style.setProperty('--mini-cart-recommendation-cards-in-view', String(visibleCards));

      if ($slider.hasClass('flickity-enabled') && (slideCount <= visibleCards || previousVisibleCards !== visibleCards)) {
        $slider.flickity('destroy');
      }

      if (slideCount <= visibleCards) {
        delete sliderEl.dataset.flickityVisibleCards;
        if ($dotsHost.length) {
          $dotsHost.attr('hidden', true).empty();
        }
        equalizeMiniCartRecommendationCardHeights(sliderEl);
        return;
      }

      if (!$slider.hasClass('flickity-enabled')) {
        $slider.flickity({
          cellAlign: 'left',
          contain: true,
          draggable: true,
          groupCells: visibleCards > 1 ? visibleCards : false,
          imagesLoaded: true,
          pageDots: true,
          prevNextButtons: false,
          wrapAround: false,
          adaptiveHeight: true
        });
        sliderEl.dataset.flickityVisibleCards = String(visibleCards);
      } else {
        $slider.flickity('resize');
        sliderEl.dataset.flickityVisibleCards = String(visibleCards);
      }

      $slider.off('.miniCartEqualHeight');
      $slider.on('ready.flickity.miniCartEqualHeight settle.flickity.miniCartEqualHeight resize.flickity.miniCartEqualHeight', () => {
        equalizeMiniCartRecommendationCardHeights(sliderEl);
      });
      equalizeMiniCartRecommendationCardHeights(sliderEl);
      window.setTimeout(() => {
        equalizeMiniCartRecommendationCardHeights(sliderEl);
      }, 160);

      if ($dotsHost.length) {
        const $pageDots = $slider.find('> .flickity-page-dots');
        if ($pageDots.length) {
          $dotsHost.removeAttr('hidden').empty().append($pageDots);
        }
      }
    });
  };
  let latestMiniCartProductFeedToken = 0;
  const getMiniCartDrawer = () => document.getElementById('mini-cart-drawer');
  const getMiniCartContext = cart => {
    if (cart && Array.isArray(cart.items)) {
      return {
        lastProductId: cart.items.length ? cart.items[cart.items.length - 1].product_id : null,
        cartHandles: new Set(cart.items.map(item => item.handle).filter(Boolean))
      };
    }
    const miniCartDrawer = getMiniCartDrawer();
    const lastProductId = miniCartDrawer ? parseInt(miniCartDrawer.dataset.lastProductId || '', 10) : 0;
    const cartHandles = miniCartDrawer && miniCartDrawer.dataset.cartHandles
      ? miniCartDrawer.dataset.cartHandles.split(',').map(handle => handle.trim()).filter(Boolean)
      : [];
    return {
      lastProductId: Number.isFinite(lastProductId) && lastProductId > 0 ? lastProductId : null,
      cartHandles: new Set(cartHandles)
    };
  };
  const updateMiniCartContext = cart => {
    const miniCartDrawer = getMiniCartDrawer();
    if (!miniCartDrawer || !cart || !Array.isArray(cart.items)) {
      return;
    }
    const lastItem = cart.items.length ? cart.items[cart.items.length - 1] : null;
    miniCartDrawer.dataset.lastProductId = lastItem && lastItem.product_id ? String(lastItem.product_id) : '';
    miniCartDrawer.dataset.cartHandles = cart.items.map(item => item.handle).filter(Boolean).join(',');
  };
  const getMiniCartProductFeedFallback = blockEl => {
    const fallbackTemplate = blockEl.querySelector('[data-mini-cart-product-feed-fallback]');
    return fallbackTemplate ? fallbackTemplate.innerHTML.trim() : '';
  };
  const setMiniCartProductFeedContent = (blockEl, html) => {
    const slider = blockEl.querySelector('[data-mini-cart-recommendations-slider]');
    const placeholder = blockEl.querySelector('[data-mini-cart-product-feed-placeholder]');
    const dotsHost = blockEl.querySelector('[data-mini-cart-recommendations-dots]');
    const trimmedHtml = String(html || '').trim();
    const showPlaceholder = !trimmedHtml && !!(window.Shopify && window.Shopify.designMode) && !!placeholder;
    if (!slider) {
      return;
    }
    if (window.jQuery) {
      const $slider = $(slider);
      if ($slider.hasClass('flickity-enabled')) {
        $slider.flickity('destroy');
      }
    }
    slider.innerHTML = trimmedHtml;
    blockEl.hidden = !trimmedHtml && !showPlaceholder;
    if (placeholder) {
      placeholder.hidden = !showPlaceholder;
    }
    if (dotsHost) {
      dotsHost.hidden = true;
      dotsHost.innerHTML = '';
    }
  };
  const restoreMiniCartProductFeedFallback = blockEl => {
    setMiniCartProductFeedContent(blockEl, getMiniCartProductFeedFallback(blockEl));
    initMiniCartRecommendationSliders();
  };
  const getMiniCartProductFeedImageUrl = product => {
    const featuredImage = product && (product.featured_image || product.featured_media || product.image);
    let src = '';
    if (typeof featuredImage === 'string') {
      src = featuredImage;
    } else if (featuredImage && typeof featuredImage === 'object') {
      src = featuredImage.src || featuredImage.url || '';
    }
    if (!src) {
      return '';
    }
    const normalizedSrc = String(src).replace(/^http:/, '');
    if (/[\?&]width=/.test(normalizedSrc)) {
      return normalizedSrc;
    }
    return `${normalizedSrc}${normalizedSrc.includes('?') ? '&' : '?'}width=240`;
  };
  const getMiniCartProductFeedSecondaryImageUrl = product => {
    const images = Array.isArray(product && product.images) ? product.images : [];
    const secondaryImage = images.length > 1 ? images[1] : null;
    let src = '';
    if (typeof secondaryImage === 'string') {
      src = secondaryImage;
    } else if (secondaryImage && typeof secondaryImage === 'object') {
      src = secondaryImage.src || secondaryImage.url || '';
    }
    if (!src) {
      return '';
    }
    const normalizedSrc = String(src).replace(/^http:/, '');
    if (/[\?&]width=/.test(normalizedSrc)) {
      return normalizedSrc;
    }
    return `${normalizedSrc}${normalizedSrc.includes('?') ? '&' : '?'}width=240`;
  };
  const productHasOnlyDefaultVariant = product => {
    if (!product) {
      return false;
    }
    if (product.has_only_default_variant) {
      return true;
    }
    const variants = Array.isArray(product.variants) ? product.variants : [];
    if (variants.length > 1) {
      return false;
    }
    const options = Array.isArray(product.options) ? product.options : [];
    if (!options.length) {
      return variants.length <= 1;
    }
    return options.every(option => {
      if (typeof option === 'string') {
        return option === 'Title';
      }
      return option && option.name === 'Title';
    });
  };
  const getMiniCartMoneyFormat = () => $('[data-cart-form="mini-cart"]').first().data('money-format') || $('body').data('money-format');
  const formatMiniCartMoney = amount => {
    if (window.PXUTheme && window.PXUTheme.currency && typeof window.PXUTheme.currency.formatMoneyNoTrailingZeros === 'function') {
      return window.PXUTheme.currency.formatMoneyNoTrailingZeros(amount, getMiniCartMoneyFormat());
    }
    return window.Shopify.formatMoney(amount, getMiniCartMoneyFormat());
  };
  const getMiniCartDisplayedSubtotal = cart => {
    const candidateAmounts = [
      cart && cart.items_subtotal_price,
      cart && cart.original_total_price,
      cart && cart.total_price
    ];
    const numericAmount = candidateAmounts.find(amount => typeof amount === 'number');
    return typeof numericAmount === 'number' ? numericAmount : 0;
  };
  const getMiniCartShippingSummaryConfig = () => {
    const $summary = $('#mini-cart-drawer .cart_content__summary').first();
    return {
      label: String($summary.data('shippingLabel') || 'Estimated shipping').trim(),
      pendingLabel: String($summary.data('shippingPendingLabel') || 'Calculating...').trim(),
      fallbackLabel: String($summary.data('shippingFallbackLabel') || 'Calculated at checkout').trim(),
      country: String($summary.data('shippingCountry') || '').trim(),
      countryCode: String($summary.data('shippingCountryCode') || '').trim(),
      province: String($summary.data('shippingProvince') || '').trim(),
      zip: String($summary.data('shippingZip') || '').trim()
    };
  };
  const normalizeMiniCartCountryValue = value => String(value || '')
    .trim()
    .toLowerCase();
  const isMiniCartUnitedStates = address => {
    const normalizedCountry = normalizeMiniCartCountryValue(address && address.country);
    const normalizedCountryCode = normalizeMiniCartCountryValue(address && address.countryCode);
    return normalizedCountryCode === 'us'
      || normalizedCountry === 'united states'
      || normalizedCountry === 'united states of america'
      || normalizedCountry === 'usa'
      || normalizedCountry === 'u.s.'
      || normalizedCountry === 'u.s.a.';
  };
  const getMiniCartShippingAddress = () => {
    const config = getMiniCartShippingSummaryConfig();
    return {
      country: config.country,
      countryCode: config.countryCode,
      province: config.province,
      zip: config.zip
    };
  };
  const getMiniCartShippingRequestKey = (cart, address) => {
    return [
      String(Number(cart && cart.total_price) || 0),
      String(address && address.country || '').trim(),
      String(address && address.countryCode || '').trim()
    ].join('||');
  };
  const updateMiniCartShippingEstimateState = nextState => {
    miniCartShippingEstimateState.status = nextState.status;
    miniCartShippingEstimateState.amount = typeof nextState.amount === 'number' ? nextState.amount : null;
    miniCartShippingEstimateState.requestKey = nextState.requestKey || '';
    miniCartShippingEstimateState.cart = nextState.cart || null;
  };
  const requestMiniCartShippingEstimate = cart => {
    const requiresShipping = !!(cart && cart.item_count > 0 && cart.requires_shipping !== false);
    const address = getMiniCartShippingAddress();
    if (!requiresShipping) {
      updateMiniCartShippingEstimateState({
        status: 'idle',
        amount: null,
        requestKey: '',
        cart
      });
      return;
    }
    if (!(address.country || address.countryCode)) {
      updateMiniCartShippingEstimateState({
        status: 'unavailable',
        amount: null,
        requestKey: 'missing-address',
        cart
      });
      return;
    }
    const requestKey = getMiniCartShippingRequestKey(cart, address);
    if (miniCartShippingEstimateState.requestKey === requestKey && ['ready', 'unavailable'].includes(miniCartShippingEstimateState.status)) {
      miniCartShippingEstimateState.cart = cart;
      return;
    }
    const isUsDestination = isMiniCartUnitedStates(address);
    const shippingAmount = isUsDestination && (Number(cart && cart.total_price) || 0) < miniCartUsFreeShippingThresholdCents
      ? miniCartUsFlatShippingCents
      : 0;
    updateMiniCartShippingEstimateState({
      status: isUsDestination ? 'ready' : 'unavailable',
      amount: isUsDestination ? shippingAmount : null,
      requestKey,
      cart
    });
  };
  const getMiniCartShippingSummaryState = cart => {
    const config = getMiniCartShippingSummaryConfig();
    const requiresShipping = !!(cart && cart.item_count > 0 && cart.requires_shipping !== false);
    if (!requiresShipping) {
      return {
        label: config.label,
        shouldShow: false,
        totalAdjustment: 0,
        valueMarkup: ''
      };
    }
    if (miniCartShippingEstimateState.status === 'ready' && typeof miniCartShippingEstimateState.amount === 'number') {
      const shippingAmount = Math.max(miniCartShippingEstimateState.amount, 0);
      const formattedShippingAmount = miniCartEscapeHtml(window.Shopify.formatMoney(shippingAmount, getMiniCartMoneyFormat()));
      const shippingValueMarkup = shippingAmount > 0
        ? `<span class="money">${formattedShippingAmount}</span>`
        : `<span class="cart_shipping__status">${miniCartEscapeHtml(window.PXUTheme.translation.cart_free_text || 'Free')}</span>`;
      return {
        label: config.label,
        shouldShow: true,
        totalAdjustment: shippingAmount,
        valueMarkup: shippingValueMarkup
      };
    }
    return {
      label: config.label,
      shouldShow: true,
      totalAdjustment: 0,
      valueMarkup: `<span class="cart_shipping__status">${miniCartEscapeHtml(config.fallbackLabel)}</span>`
    };
  };
  const isMiniCartGenericDiscountTitle = title => {
    const normalizedTitle = normalizeMiniCartSignatureRewardsValue(title);
    const genericDiscountLabel = normalizeMiniCartSignatureRewardsValue(window.PXUTheme.translation.cart_discount_text || 'Discount');
    return !normalizedTitle || normalizedTitle === genericDiscountLabel || normalizedTitle === 'discount';
  };
  const getMiniCartDiscountRowTitle = ({ discount = null, storedRewardCode = '', storedRewardTitle = '', allowStoredFallback = true } = {}) => {
    const explicitTitle = String(discount && discount.title ? discount.title : '').trim();
    if (!isMiniCartGenericDiscountTitle(explicitTitle)) {
      return explicitTitle;
    }
    if (allowStoredFallback) {
      return String(storedRewardCode || storedRewardTitle || '').trim();
    }
    return '';
  };
  const getMiniCartCartDiscountRows = cart => {
    const applications = Array.isArray(cart && cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    const storedReward = getMiniCartSignatureRewardsCartSnapshot(cart) || miniCartSignatureRewardsUiState.appliedRewardSnapshot || getMiniCartSignatureRewardsStoredReward();
    const storedRewardCode = String(getMiniCartSignatureRewardsRewardCode(storedReward) || '').trim();
    const storedRewardTitle = String(getMiniCartSignatureRewardsRewardTitle(storedReward) || '').trim();
    if (!applications.length) {
      const totalDiscount = Number(cart && cart.total_discount) || 0;
      const fallbackTitle = getMiniCartDiscountRowTitle({
        storedRewardCode,
        storedRewardTitle
      });
      if (totalDiscount <= 0) {
        return [];
      }
      if (!fallbackTitle) {
        return [];
      }
      return [{
        title: fallbackTitle,
        amount: totalDiscount
      }];
    }
    let rewardDiscountIndex = -1;
    if (storedReward && storedRewardCode) {
      rewardDiscountIndex = applications.findIndex(discount => doesMiniCartSignatureRewardsDiscountMatchReward(discount, storedReward));
      if (rewardDiscountIndex === -1 && applications.length === 1) {
        rewardDiscountIndex = 0;
      }
    }
    return applications
      .map((discount, index) => {
        const amount = Number(discount && discount.total_allocated_amount) || 0;
        if (amount <= 0) {
          return null;
        }
        const title = index === rewardDiscountIndex
          ? getMiniCartDiscountRowTitle({
            discount,
            storedRewardCode,
            storedRewardTitle
          })
          : getMiniCartDiscountRowTitle({
            discount,
            allowStoredFallback: false
          });
        if (!title) {
          return null;
        }
        return {
          title,
          amount
        };
      })
      .filter(Boolean);
  };
  const renderMiniCartSummary = cart => {
    const $summary = $('#mini-cart-drawer .cart_content__summary').first();
    const $totalRow = $summary.find('.js-cart_estimated_total').first();
    if (!$summary.length || !$totalRow.length) {
      return;
    }
    requestMiniCartShippingEstimate(cart);
    const subtotalLabel = String($summary.data('subtotalLabel') || window.PXUTheme.translation.cart_subtotal_text || 'Subtotal').trim();
    const estimatedTotalLabel = String($totalRow.data('label') || 'Estimated Total').trim();
    const discountRows = getMiniCartCartDiscountRows(cart);
    const shippingRowState = getMiniCartShippingSummaryState(cart);
    const summarySubtotal = getMiniCartDisplayedSubtotal(cart);
    const summaryTotal = Math.max((Number(cart && cart.total_price) || 0) + shippingRowState.totalAdjustment, 0);
    const summaryMoneyFormat = getMiniCartMoneyFormat();
    const formatSummaryMoney = amount => miniCartEscapeHtml(window.Shopify.formatMoney(amount, summaryMoneyFormat));
    let summaryMarkup = `<li class="cart_subtotal js-cart_subtotal"><span>${miniCartEscapeHtml(subtotalLabel)}</span><span class="right"><span class="money">${formatSummaryMoney(summarySubtotal)}</span></span></li>`;
    discountRows.forEach(discount => {
      summaryMarkup += `<li class="cart_discounts js-cart_discount"><span class="cart_discounts--title">${miniCartEscapeHtml(discount.title)}</span><span class="right cart_discounts--price">-${formatSummaryMoney(discount.amount)}</span></li>`;
    });
    if (shippingRowState.shouldShow) {
      summaryMarkup += `<li class="cart_shipping js-cart_estimated_shipping"><span>${miniCartEscapeHtml(shippingRowState.label)}</span><span class="right">${shippingRowState.valueMarkup}</span></li>`;
    }
    $summary.find('.js-cart_subtotal, .js-cart_discount, .js-cart_estimated_shipping').remove();
    $totalRow.before(summaryMarkup);
    $totalRow.attr('data-label', estimatedTotalLabel).html(`<span>${miniCartEscapeHtml(estimatedTotalLabel)}</span><span class="right"><span class="money">${formatSummaryMoney(summaryTotal)}</span></span>`);
  };
  const getMiniCartProductFeedVariants = product => {
    const variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (!variants.length) {
      return [];
    }
    const availableVariants = variants.filter(variant => variant && variant.available);
    return availableVariants.length ? availableVariants : variants;
  };
  const getMiniCartProductFeedSwatchOptionIndex = product => {
    const swatchableNames = ['color', 'colour', 'hardware', 'metal'];
    const options = Array.isArray(product && product.options) ? product.options : [];
    return options.findIndex(option => {
      const optionName = typeof option === 'string' ? option : option && option.name;
      return swatchableNames.includes(String(optionName || '').toLowerCase());
    });
  };
  const getMiniCartProductFeedVariantOptionValue = (variant, optionIndex) => {
    if (!variant || optionIndex < 0) {
      return '';
    }
    if (Array.isArray(variant.options) && typeof variant.options[optionIndex] !== 'undefined') {
      return variant.options[optionIndex];
    }
    return variant[`option${optionIndex + 1}`] || '';
  };
  const handleizeMiniCartSwatchValue = value => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const getMiniCartSwatchImageUrl = (template, value) => {
    if (!template || !value) {
      return '';
    }
    return String(template).replace('__SWATCH__', handleizeMiniCartSwatchValue(value));
  };
  const getMiniCartProductFeedVariant = product => {
    const variants = getMiniCartProductFeedVariants(product);
    if (!variants.length) {
      return null;
    }
    return variants[0];
  };
  const buildMiniCartProductFeedVariantPicker = (product, selectedVariantId, options = {}) => {
    const variants = getMiniCartProductFeedVariants(product);
    if (!variants.length || productHasOnlyDefaultVariant(product)) {
      return '';
    }
    const swatchOptionIndex = getMiniCartProductFeedSwatchOptionIndex(product);
    const selectedVariant = variants.find(variant => String(variant.id) === String(selectedVariantId)) || variants[0];
    const selectedSwatchValue = swatchOptionIndex > -1
      ? getMiniCartProductFeedVariantOptionValue(selectedVariant, swatchOptionIndex)
      : '';
    const renderedSwatchValues = new Set();
    const pickerButtons = variants.map(variant => {
      const swatchValue = swatchOptionIndex > -1
        ? getMiniCartProductFeedVariantOptionValue(variant, swatchOptionIndex)
        : (variant.title || '');
      if (swatchOptionIndex > -1) {
        const lookupKey = String(swatchValue || '').toLowerCase();
        if (renderedSwatchValues.has(lookupKey)) {
          return '';
        }
        renderedSwatchValues.add(lookupKey);
      }
      const isSelected = swatchOptionIndex > -1
        ? String(swatchValue) === String(selectedSwatchValue)
        : String(variant.id) === String(selectedVariantId);
      const isColorSwatch = swatchOptionIndex > -1;
      const swatchImageUrl = isColorSwatch ? getMiniCartSwatchImageUrl(options.swatchImageTemplate, swatchValue) : '';
      const swatchStyle = isColorSwatch
        ? ` style="background-color: ${htmlEncode(String(swatchValue || '').toLowerCase().replace(/\s+/g, ''))};${swatchImageUrl ? ` background-image: url(${htmlEncode(swatchImageUrl)});` : ''}"`
        : '';
      return `<button type="button" class="mini-cart__recommendation-variant-swatch${isColorSwatch ? ' is-color' : ''}${isSelected ? ' is-selected' : ''}" data-mini-cart-variant-swatch data-variant-id="${variant.id}" data-price="${variant.price}" data-compare-price="${variant.compare_at_price || 0}" aria-pressed="${isSelected ? 'true' : 'false'}" aria-label="${htmlEncode(swatchValue || variant.title || '')}"${swatchStyle}><span class="mini-cart__recommendation-variant-label">${htmlEncode(swatchValue || variant.title || '')}</span></button>`;
    }).join('');
    return `<div class="mini-cart__recommendation-variant-picker" role="group" aria-label="Choose a variant for ${htmlEncode(product.title || '')}">${pickerButtons}</div>`;
  };
  const buildMiniCartProductFeedCard = (product, options = {}) => {
    const variant = getMiniCartProductFeedVariant(product);
    if (!product || !variant) {
      return '';
    }
    const productUrl = product.url || (product.handle ? `${window.Shopify.routes.root}products/${product.handle}` : '#');
    const imageUrl = getMiniCartProductFeedImageUrl(product);
    const secondaryImageUrl = getMiniCartProductFeedSecondaryImageUrl(product);
    const title = htmlEncode(product.title || '');
    const price = typeof variant.price === 'number'
      ? formatMiniCartMoney(variant.price)
      : window.PXUTheme.translation.cart_free_text;
    const buttonLabel = htmlEncode(options.buttonLabel || 'Add to bag');
    const soldOutLabel = htmlEncode(window.PXUTheme.translation.sold_out_text || 'Sold Out');
    const cardStyle = String(options.cardStyle || 'standard').trim();
    const defaultButtonStyleClass = cardStyle === 'cp_featured'
      ? ((window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cp_product_card_button_style) || 'global-button--secondary')
      : 'global-button--secondary';
    const buttonStyleClass = htmlEncode(String(options.buttonStyle || defaultButtonStyleClass).trim() || defaultButtonStyleClass);
    const cardClasses = ['mini-cart__recommendation-card', 'gallery-cell'];
    if (cardStyle === 'cp_featured') {
      cardClasses.push('mini-cart__recommendation-card--cp');
    }
    if (!imageUrl) {
      cardClasses.push('mini-cart__recommendation-card--no-image');
    }
    let cardHtml = `<article class="${cardClasses.join(' ')}" data-mini-cart-recommendation-slide>`;
    if (imageUrl) {
      cardHtml += `<a href="${productUrl}" class="mini-cart__recommendation-image${cardStyle === 'cp_featured' ? ' mini-cart__recommendation-image--cp' : ''}"><img src="${imageUrl}" alt="${title}" class="mini-cart__recommendation-img" loading="lazy" />`;
      if (cardStyle === 'cp_featured' && secondaryImageUrl) {
        cardHtml += `<img src="${secondaryImageUrl}" alt="${title}" class="mini-cart__recommendation-img mini-cart__recommendation-img--secondary" loading="lazy" />`;
      }
      cardHtml += '</a>';
    }
    cardHtml += '<div class="mini-cart__recommendation-content"><div class="mini-cart__recommendation-header">'
      + `<a href="${productUrl}" class="mini-cart__recommendation-title">${title}</a>`
      + '</div>';
    if (variant.available) {
      cardHtml += buildMiniCartProductFeedVariantPicker(product, variant.id, options);
      cardHtml += `<button type="button" class="global-button ${buttonStyleClass}${cardStyle === 'cp_featured' ? ' mini-cart__recommendation-button--cp' : ''} mini-cart__recommendation-button" data-mini-cart-upsell-add data-variant-id="${variant.id}" data-button-label="${buttonLabel}"><span class="mini-cart__recommendation-button-label">${buttonLabel}</span><span class="mini-cart__recommendation-button-price">&nbsp;${price}</span></button>`;
    } else {
      cardHtml += `<span class="mini-cart__recommendation-sold-out">${soldOutLabel}</span>`;
    }
    cardHtml += '</div><div class="mini-cart__recommendation-spacer" aria-hidden="true"></div></article>';
    return cardHtml;
  };
  const loadMiniCartShopifyRecommendations = (blockEl, context, token) => {
    const slider = blockEl.querySelector('[data-mini-cart-recommendations-slider]');
    const productId = parseInt(context.lastProductId || (slider && slider.dataset.productId ? slider.dataset.productId : ''), 10);
    const limit = parseInt(slider && slider.dataset.limit ? slider.dataset.limit : '', 10) || 3;
    const intent = slider && slider.dataset.intent ? slider.dataset.intent : 'related';
    if (!slider || !productId) {
      restoreMiniCartProductFeedFallback(blockEl);
      return;
    }
    slider.dataset.productId = String(productId);
    $.ajax({
      dataType: 'json',
      cache: false,
      url: `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`,
      success(response) {
        if (token !== latestMiniCartProductFeedToken) {
          return;
        }
        const recommendedProducts = Array.isArray(response && response.products) ? response.products : [];
        const visibleProducts = recommendedProducts.filter(product => !context.cartHandles.has(product.handle)).slice(0, limit);
        const productCards = visibleProducts.map(product => buildMiniCartProductFeedCard(product, {
          buttonLabel: slider.dataset.buttonLabel,
          buttonStyle: slider.dataset.buttonStyle,
          chooseOptionsLabel: slider.dataset.chooseOptionsLabel,
          cardStyle: slider.dataset.cardStyle,
          swatchImageTemplate: slider.dataset.swatchImageTemplate
        })).join('');
        if (productCards) {
          setMiniCartProductFeedContent(blockEl, productCards);
          initMiniCartRecommendationSliders();
        } else {
          restoreMiniCartProductFeedFallback(blockEl);
        }
      },
      error() {
        if (token === latestMiniCartProductFeedToken) {
          restoreMiniCartProductFeedFallback(blockEl);
        }
      }
    });
  };
  const loadMiniCartRecentlyViewedProducts = (blockEl, context, token) => {
    const slider = blockEl.querySelector('[data-mini-cart-recommendations-slider]');
    const limit = parseInt(slider && slider.dataset.limit ? slider.dataset.limit : '', 10) || 3;
    const recentlyViewedCookie = window.Cookies ? window.Cookies.get('recentlyViewed') : '';
    const recentlyViewedHandles = recentlyViewedCookie
      ? unescape(recentlyViewedCookie).split(',').map(handle => handle.trim()).filter(Boolean)
      : [];
    const uniqueHandles = [...new Set(recentlyViewedHandles)].filter(handle => !context.cartHandles.has(handle)).slice(0, limit);
    if (!slider || !uniqueHandles.length) {
      restoreMiniCartProductFeedFallback(blockEl);
      return;
    }
    Promise.all(uniqueHandles.map(handle => new Promise(resolve => {
      $.ajax({
        dataType: 'json',
        cache: false,
        url: `${window.Shopify.routes.root}products/${handle}.js`,
        success(data) {
          resolve(data);
        },
        error() {
          resolve(null);
        }
      });
    }))).then(products => {
      if (token !== latestMiniCartProductFeedToken) {
        return;
      }
      const productCards = products
        .filter(Boolean)
        .slice(0, limit)
        .map(product => buildMiniCartProductFeedCard(product, {
          buttonLabel: slider.dataset.buttonLabel,
          buttonStyle: slider.dataset.buttonStyle,
          chooseOptionsLabel: slider.dataset.chooseOptionsLabel,
          cardStyle: slider.dataset.cardStyle,
          swatchImageTemplate: slider.dataset.swatchImageTemplate
        }))
        .join('');
      if (productCards) {
        setMiniCartProductFeedContent(blockEl, productCards);
        initMiniCartRecommendationSliders();
      } else {
        restoreMiniCartProductFeedFallback(blockEl);
      }
    });
  };
  const initMiniCartDynamicProductBlocks = cart => {
    const miniCartDrawer = getMiniCartDrawer();
    if (!miniCartDrawer) {
      return;
    }
    const context = getMiniCartContext(cart);
    const token = ++latestMiniCartProductFeedToken;
    miniCartDrawer.querySelectorAll('[data-mini-cart-product-feed-source]').forEach(blockSlider => {
      const blockEl = blockSlider.closest('[data-mini-cart-product-feed-block]');
      if (!blockEl) {
        return;
      }
      const source = blockSlider.dataset.miniCartProductFeedSource;
      if (source === 'shopify_recommendations') {
        loadMiniCartShopifyRecommendations(blockEl, context, token);
      } else if (source === 'recently_viewed_products') {
        loadMiniCartRecentlyViewedProducts(blockEl, context, token);
      }
    });
  };

  const hoistMiniCartDrawer = () => {
    const miniCartDrawers = Array.from(document.querySelectorAll('#mini-cart-drawer'));
    if (!miniCartDrawers.length) {
      return;
    }

    const miniCartDrawer = miniCartDrawers[miniCartDrawers.length - 1];
    miniCartDrawers.slice(0, -1).forEach(drawer => drawer.remove());

    if (miniCartDrawer.parentElement === document.body) {
      initMiniCartRecommendationSliders();
      initMiniCartDynamicProductBlocks();
      observeMiniCartGoogleWidgetState();
      refreshMiniCartJoyInline({ forceRemount: true, delay: 150 });
      if (window.PXUTheme && window.PXUTheme.miniCartEditorLocked) {
        setMiniCartEditorPreviewState(true);
      }
      return;
    }

    document.body.appendChild(miniCartDrawer);
    initMiniCartRecommendationSliders();
    initMiniCartDynamicProductBlocks();
    observeMiniCartGoogleWidgetState();
    refreshMiniCartJoyInline({ forceRemount: true, delay: 150 });

    if (window.PXUTheme && window.PXUTheme.miniCartEditorLocked) {
      setMiniCartEditorPreviewState(true);
    }
  };

  hoistMiniCartDrawer();
  scheduleMiniCartJoyTriggerWrap();
  document.addEventListener('shopify:section:load', hoistMiniCartDrawer);
  window.addEventListener('joy:ready', () => {
    miniCartJoyTriggerWrapAttempts = 0;
    scheduleMiniCartJoyTriggerWrap();
    refreshMiniCartJoyInline({ forceRemount: true, delay: 0 });
  });
  ['joy:applyCoupon', 'joy:redeemCoupon'].forEach(eventName => {
    window.addEventListener(eventName, event => {
      const eventDetail = event && event.detail ? event.detail : {};
      const hydratedEventReward = getMiniCartSignatureRewardsHydratedReward(
        eventDetail.reward || eventDetail.discount || eventDetail,
        miniCartSignatureRewardsUiState.appliedRewardSnapshot || getMiniCartSignatureRewardsStoredReward()
      );
      if (getMiniCartSignatureRewardsRewardCode(hydratedEventReward)) {
        persistMiniCartSignatureRewardsAppliedReward(hydratedEventReward);
      }
      syncMiniCartCartFromJoy();
    });
  });
  window.addEventListener('joy:revokeCoupon', () => {
    clearMiniCartSignatureRewardsAppliedReward();
    syncMiniCartCartFromJoy();
  });
  document.addEventListener('click', event => {
    const target = event && event.target;
    if (!(target instanceof Element)) {
      return;
    }
    const button = target.closest('#mini-cart-drawer [data-mini-cart-joy-revoke]');
    if (!button) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    void handleMiniCartSignatureRewardsRevokeButton(button);
  }, true);

  if (isThemeEditor) {
    const isMiniCartEditorEvent = event => {
      const miniCartDrawer = document.getElementById('mini-cart-drawer');
      return !!(
        miniCartDrawer
        && event
        && event.detail
        && event.detail.sectionId
        && miniCartDrawer.dataset.sectionId === event.detail.sectionId
      );
    };

    document.addEventListener('shopify:section:select', event => {
      if (isMiniCartEditorEvent(event)) {
        hoistMiniCartDrawer();
        setMiniCartEditorPreviewState(true);
      }
    });

    document.addEventListener('shopify:block:select', event => {
      if (isMiniCartEditorEvent(event)) {
        hoistMiniCartDrawer();
        setMiniCartEditorPreviewState(true);
      }
    });

    document.addEventListener('shopify:section:deselect', event => {
      if (isMiniCartEditorEvent(event)) {
        setMiniCartEditorPreviewState(false);
      }
    });
  }

  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const {
    pathname
  } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (
          currentScreenWidth !== beforeResizeWidth
          && (
            window.PXUTheme.media_queries.header_mobile.matches
            || beforeResizeWidth <= 1024
          )
        ) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#tag_filter', () => {
    $('[data-option-filter] input').prop('checked', false);
    window.quickFilter.init();
  });
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });
  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: $('.content').offset().top
    }, 500);
  });

    // CUSTOM CODE: Mobile Apply Button Logic
  $('body').on('click', '.js-mobile-apply', (e) => {
      e.preventDefault();
      window.quickFilter.init();

      // Close sidebar and overlay
      $('.sidebar').removeClass('is-open');
      $('.sidebar-overlay').removeClass('is-visible');
      $('body').removeClass('scroll-locked');

      $('html, body').animate({
        scrollTop: $('.content').offset().top
      }, 500);
  });

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });
  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).on('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.PXUTheme.theme_settings.enable_back_to_top_button) {
    window.back_to_top_button.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2
  });
  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', function (e) {
      const $cartContent = $(this).closest('.cart_content');
      const $cartForm = $cartContent.find('[data-cart-form="mini-cart"]').first();
      if (!$cartForm.length) {
        return;
      }
      if (!window.PXUTheme.theme_settings.go_to_checkout) {
        e.preventDefault();
        document.location.href = window.PXUTheme.routes.cart_url;
        return;
      }
      const $tosCheckbox = $cartForm.find('.tos_agree');
      if ($tosCheckbox.length && !$tosCheckbox.is(':checked')) {
        e.preventDefault();
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($cartContent.find('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
      e.preventDefault();
      const formEl = $cartForm.get(0);
      if (!formEl) {
        return;
      }
      if (typeof formEl.requestSubmit === 'function') {
        const submitter = document.createElement('button');
        submitter.type = 'submit';
        submitter.name = 'checkout';
        submitter.hidden = true;
        formEl.appendChild(submitter);
        formEl.requestSubmit(submitter);
        submitter.remove();
      } else {
        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'checkout';
        formEl.appendChild(checkoutInput);
        formEl.submit();
      }
    });
  }
  function setMiniCartNoteStatus(message, tone) {
    const normalizedTone = tone || '';
    $('[data-cart-note-status]').each(function () {
      const $status = $(this);
      $status
        .removeClass('is-success is-error is-saving')
        .text(message || '');
      if (normalizedTone) {
        $status.addClass(`is-${normalizedTone}`);
      }
    });
  }
  function saveMiniCartNote(noteValue) {
    const $saveButtons = $('[data-cart-note-save]');
    $saveButtons.prop('disabled', true).attr('aria-busy', 'true');
    setMiniCartNoteStatus('Saving note...', 'saving');
    $.ajax({
      url: `${window.Shopify.routes.root}cart/update.js`,
      dataType: 'json',
      cache: false,
      type: 'post',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        note: noteValue
      }),
      success() {
        setMiniCartNoteStatus('Note saved.', 'success');
      },
      error() {
        setMiniCartNoteStatus('We could not save that note right now. Please try again.', 'error');
      },
      complete() {
        $saveButtons.prop('disabled', false).removeAttr('aria-busy');
      }
    });
  }
  $('body').on('input', '[data-cart-note]', function () {
    setMiniCartNoteStatus('', '');
  });
  $('body').on('change', '[data-cart-note]', function () {
    saveMiniCartNote($(this).val());
  });
  $('body').on('click', '[data-cart-note-save]', function (event) {
    event.preventDefault();
    const noteValue = $('[data-cart-note]').first().val() || '';
    saveMiniCartNote(noteValue);
  });
  $('body').on('click', '.joy-small-hide', function () {
    closeMiniCartBeforeJoyWidget();
  });
  $('body').on('mousedown click touchstart', '[data-mini-cart-signature-rewards], [data-mini-cart-signature-rewards] *, [data-mini-cart-signature-rewards-featured], [data-mini-cart-signature-rewards-featured] *', function (event) {
    event.stopPropagation();
  });
  $('body').on('click', '[data-mini-cart-signature-rewards-toggle]', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if ($(this).prop('disabled')) {
      return;
    }
    miniCartSignatureRewardsUiState.expanded = !miniCartSignatureRewardsUiState.expanded;
    renderMiniCartSignatureRewards(miniCartSignatureRewardsStateCache || {
      customer: {},
      programs: [],
      rewards: [],
      branding: {},
      cart: {}
    });
  });
  $('body').on('click', '[data-mini-cart-signature-rewards-cancel]', function (event) {
    event.preventDefault();
    event.stopPropagation();
    miniCartSignatureRewardsUiState.expanded = false;
    renderMiniCartSignatureRewards(miniCartSignatureRewardsStateCache || {
      customer: {},
      programs: [],
      rewards: [],
      branding: {},
      cart: {}
    });
  });
  $('body').on('click', '[data-mini-cart-signature-rewards-featured-cancel]', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (miniCartSignatureRewardsStateCache) {
      resetMiniCartSignatureRewardsFeaturedSelection(miniCartSignatureRewardsStateCache);
      renderMiniCartSignatureRewardsFeatured(miniCartSignatureRewardsStateCache);
    }
  });
  $('body').on('click', '[data-mini-cart-signature-rewards-featured-select]', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (miniCartSignatureRewardsStateCache && getMiniCartSignatureRewardsAppliedReward(miniCartSignatureRewardsStateCache.rewards, miniCartSignatureRewardsStateCache.cart)) {
      return;
    }
    const programId = String($(this).attr('data-program-id') || $(this).data('programId') || '').trim();
    if (!programId) {
      return;
    }
    miniCartSignatureRewardsFeaturedUiState.selectedProgramId = programId;
    if (miniCartSignatureRewardsStateCache) {
      const customerPoints = Number(miniCartSignatureRewardsStateCache.customer && miniCartSignatureRewardsStateCache.customer.point) || 0;
      const { rewardOptions } = getMiniCartSignatureRewardsFeaturedPrograms(miniCartSignatureRewardsStateCache);
      const selectedProgram = (Array.isArray(rewardOptions) ? rewardOptions : []).find(program => program.id === programId) || null;
      ensureMiniCartSignatureRewardsFeaturedDynamicPointsInput(selectedProgram, customerPoints);
      renderMiniCartSignatureRewardsFeatured(miniCartSignatureRewardsStateCache);
    }
  });
  $('body').on('keydown', '[data-mini-cart-signature-rewards-featured-select]', function (event) {
    if (miniCartSignatureRewardsStateCache && getMiniCartSignatureRewardsAppliedReward(miniCartSignatureRewardsStateCache.rewards, miniCartSignatureRewardsStateCache.cart)) {
      return;
    }
    if (!(event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar')) {
      return;
    }
    event.preventDefault();
    $(this).trigger('click');
  });
  $('body').on('click', '[data-mini-cart-signature-rewards-featured-adjust]', function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (miniCartSignatureRewardsStateCache && getMiniCartSignatureRewardsAppliedReward(miniCartSignatureRewardsStateCache.rewards, miniCartSignatureRewardsStateCache.cart)) {
      return;
    }
    const adjustment = parseInt($(this).attr('data-mini-cart-signature-rewards-featured-adjust'), 10) || 0;
    const programId = String($(this).attr('data-program-id') || $(this).data('programId') || '').trim();
    if (!adjustment || !miniCartSignatureRewardsStateCache) {
      return;
    }
    miniCartSignatureRewardsFeaturedUiState.selectedProgramId = programId;
    const context = getMiniCartSignatureRewardsFeaturedContext(miniCartSignatureRewardsStateCache);
    const dynamicProgram = context.dynamicProgram;
    const dynamicState = context.dynamicState;
    if (!(dynamicProgram && dynamicState)) {
      return;
    }
    const nextValue = Math.max(dynamicState.min, Math.min(dynamicState.max, dynamicState.value + (adjustment * dynamicState.step)));
    miniCartSignatureRewardsFeaturedUiState.pointsInput = String(nextValue);
    updateMiniCartSignatureRewardsFeaturedFormState();
  });
  $('body').on('input change', '[data-mini-cart-signature-rewards-featured-range]', function (event) {
    event.stopPropagation();
    if (miniCartSignatureRewardsStateCache && getMiniCartSignatureRewardsAppliedReward(miniCartSignatureRewardsStateCache.rewards, miniCartSignatureRewardsStateCache.cart)) {
      return;
    }
    miniCartSignatureRewardsFeaturedUiState.selectedProgramId = String($(this).attr('data-program-id') || $(this).data('programId') || '').trim();
    miniCartSignatureRewardsFeaturedUiState.pointsInput = String($(this).val() || '').replace(/[^\d]/g, '');
    updateMiniCartSignatureRewardsFeaturedFormState();
  });
  $('body').on('change', '[data-mini-cart-joy-program-select]', function () {
    miniCartSignatureRewardsUiState.selectedProgramId = String($(this).val() || '').trim();
    const availablePrograms = miniCartSignatureRewardsStateCache
      ? getMiniCartSignatureRewardsAvailablePrograms(miniCartSignatureRewardsStateCache)
      : [];
    getMiniCartSignatureRewardsSelectedProgram(availablePrograms);
    miniCartSignatureRewardsUiState.pointsInput = '';
    if (miniCartSignatureRewardsStateCache) {
      renderMiniCartSignatureRewards(miniCartSignatureRewardsStateCache);
    }
  });
  $('body').on('input', '[data-mini-cart-joy-points-input]', function () {
    const sanitizedInput = String($(this).val() || '').replace(/[^\d]/g, '');
    miniCartSignatureRewardsUiState.pointsInput = sanitizedInput;
    $(this).val(sanitizedInput);
    updateMiniCartSignatureRewardsFormState();
  });
  $('body').on('click', '[data-mini-cart-joy-open-page]', function (event) {
    event.preventDefault();
    closeMiniCartBeforeJoyWidget();
    const page = $(this).data('miniCartJoyOpenPage') || 'howToRedeem';
    if (window.joyInstance && typeof window.joyInstance.openPage === 'function') {
      window.joyInstance.openPage(page);
    } else if (window.joyInstance && typeof window.joyInstance.openWidget === 'function') {
      window.joyInstance.openWidget();
    }
  });
  $('body').on('click', '[data-mini-cart-joy-redeem]', async function (event) {
    event.preventDefault();
    event.stopPropagation();
    const $button = $(this);
    const programId = String($button.data('programId') || '').trim();
    const pointsRequiredRaw = String($button.data('points') || '').trim();
    const pointsRequired = pointsRequiredRaw ? parseInt(pointsRequiredRaw, 10) : undefined;
    if (!programId) {
      return;
    }
    miniCartSignatureRewardsUiState.expanded = true;
    $button.prop('disabled', true).attr('aria-busy', 'true');
    renderMiniCartSignatureRewardsLoading('Applying your reward...');
    try {
      const updatedCart = await applyMiniCartSignatureRewardsProgram(programId, pointsRequired);
      if (window.joyInstance && typeof window.joyInstance.updateCustomerState === 'function') {
        window.joyInstance.updateCustomerState();
      }
      refreshCart(updatedCart);
      refreshMiniCartSignatureRewards({ delay: 200, cart: updatedCart });
    } catch (error) {
      renderMiniCartSignatureRewardsError(getMiniCartSignatureRewardsErrorMessage(error, 'We could not apply that reward right now.'));
      refreshMiniCartSignatureRewards({ delay: 800 });
    } finally {
      $button.prop('disabled', false).removeAttr('aria-busy');
    }
  });
  $('body').on('click', '[data-mini-cart-signature-rewards-featured-apply]', async function (event) {
    event.preventDefault();
    event.stopPropagation();
    const $button = $(this);
    const programId = String($button.data('programId') || '').trim();
    const pointsRequiredRaw = String($button.data('points') || '').trim();
    const pointsRequired = pointsRequiredRaw ? parseInt(pointsRequiredRaw, 10) : undefined;
    if (!programId) {
      return;
    }
    $button.prop('disabled', true).attr('aria-busy', 'true');
    renderMiniCartSignatureRewardsFeaturedLoading('Applying your reward...');
    try {
      const updatedCart = await applyMiniCartSignatureRewardsProgram(programId, pointsRequired);
      if (window.joyInstance && typeof window.joyInstance.updateCustomerState === 'function') {
        window.joyInstance.updateCustomerState();
      }
      refreshCart(updatedCart);
      refreshMiniCartSignatureRewards({ delay: 200, cart: updatedCart });
    } catch (error) {
      renderMiniCartSignatureRewardsFeaturedError(getMiniCartSignatureRewardsErrorMessage(error, 'We could not apply that reward right now.'));
      refreshMiniCartSignatureRewards({ delay: 800 });
    } finally {
      $button.prop('disabled', false).removeAttr('aria-busy');
    }
  });
  $('body').on('click', '[data-mini-cart-joy-revoke]', async function (event) {
    event.preventDefault();
    event.stopPropagation();
    void handleMiniCartSignatureRewardsRevokeButton(this);
  });
  $('body').on('click', '[data-mini-cart-variant-swatch]', function (event) {
    event.preventDefault();
    const $swatch = $(this);
    const $card = $swatch.closest('.mini-cart__recommendation-card');
    const $picker = $swatch.closest('.mini-cart__recommendation-variant-picker');
    const $button = $card.find('[data-mini-cart-upsell-add]').first();
    const variantId = parseInt($swatch.data('variantId'), 10);
    const variantPrice = parseInt($swatch.data('price'), 10);
    const variantComparePrice = parseInt($swatch.data('comparePrice'), 10);
    $picker.find('[data-mini-cart-variant-swatch]').removeClass('is-selected').attr('aria-pressed', 'false');
    $swatch.addClass('is-selected').attr('aria-pressed', 'true');
    if (variantId) {
      $button.attr('data-variant-id', variantId);
    }
    if (!Number.isNaN(variantPrice)) {
      $button.find('.mini-cart__recommendation-button-price').html(`&nbsp;${formatMiniCartMoney(variantPrice)}`);
      $card.find('.mini-cart__recommendation-price-value').text(formatMiniCartMoney(variantPrice));
    }
    const $comparePrice = $card.find('.mini-cart__recommendation-price-compare').first();
    if ($comparePrice.length) {
      if (!Number.isNaN(variantComparePrice) && variantComparePrice > variantPrice) {
        $comparePrice.text(formatMiniCartMoney(variantComparePrice)).show();
      } else {
        $comparePrice.text('').hide();
      }
    }
  });
  $('body').on('click', '[data-mini-cart-upsell-add]', function (event) {
    event.preventDefault();
    const $button = $(this);
    const $card = $button.closest('.mini-cart__recommendation-card');
    const $selectedSwatch = $card.find('[data-mini-cart-variant-swatch].is-selected').first();
    const variantId = parseInt($selectedSwatch.length ? $selectedSwatch.data('variantId') : $button.attr('data-variant-id'), 10);
    if (!variantId || $button.prop('disabled')) {
      return;
    }
    $button.attr('data-variant-id', variantId);
    $button.prop('disabled', true).attr('aria-busy', 'true');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        id: variantId,
        quantity: 1
      },
      success(data) {
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          type: 'get',
          success(cart) {
            refreshCart(cart);
            const $targetCartContainer = getOpenableCartContainer();
            if ($targetCartContainer && $targetCartContainer.length && window.header && typeof window.header.openMiniCart === 'function') {
              window.header.openMiniCart($targetCartContainer, {
                autoCloseMs: 3000
              });
            }
            window.dispatchEvent(new CustomEvent('cart:item-added', {
              bubbles: true,
              detail: data
            }));
          }
        });
      },
      complete() {
        $button.prop('disabled', false).removeAttr('aria-busy');
      }
    });
  });
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('[data-product-list]');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('[data-product-list]');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }
          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      }
    });
  }
  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');
    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');
      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }
  const cartProductDataCache = {};
  let latestCartRefreshToken = 0;
  function getMiniCartDiscountDisplayLabel(discountApplication) {
    const application = discountApplication && discountApplication.discount_application
      ? discountApplication.discount_application
      : (discountApplication || {});
    return String(application.code || application.title || '').trim();
  }
  function getMiniCartRawLineDiscountAllocations(item) {
    const lineLevelAllocations = Array.isArray(item && item.line_level_discount_allocations)
      ? item.line_level_discount_allocations
      : [];
    if (lineLevelAllocations.length) {
      return lineLevelAllocations;
    }
    const discountEntries = Array.isArray(item && item.discounts) ? item.discounts : [];
    return discountEntries.map(discount => ({
      amount: discount && typeof discount.amount !== 'undefined' ? discount.amount : 0,
      discount_application: {
        code: discount && discount.code,
        title: discount && discount.title,
        target_selection: discount && discount.target_selection,
        allocation_method: discount && discount.allocation_method
      }
    }));
  }
  function getMiniCartCartLevelDiscountTitles(cart) {
    const titles = (cart && Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [])
      .map(discount => getMiniCartDiscountDisplayLabel(discount))
      .filter(Boolean);
    const cartRewardSnapshot = getMiniCartSignatureRewardsCartSnapshot(cart);
    [getMiniCartSignatureRewardsRewardCode(cartRewardSnapshot), getMiniCartSignatureRewardsRewardTitle(cartRewardSnapshot)]
      .map(value => String(value || '').trim())
      .filter(Boolean)
      .forEach(value => {
        if (!titles.includes(value)) {
          titles.push(value);
        }
      });
    return titles;
  }
  function getVisibleMiniCartLineLevelDiscounts(item, cart) {
    const allocations = getMiniCartRawLineDiscountAllocations(item);
    if (!allocations.length) {
      return [];
    }
    const cartLevelTitles = new Set(getMiniCartCartLevelDiscountTitles(cart));
    return allocations.filter(allocation => {
      const application = allocation && allocation.discount_application ? allocation.discount_application : {};
      const title = getMiniCartDiscountDisplayLabel(application);
      const targetSelection = String(application.target_selection || '').trim().toLowerCase();
      const allocationMethod = String(application.allocation_method || '').trim().toLowerCase();
      if (!title) {
        return targetSelection !== 'all' && allocationMethod !== 'across';
      }
      if (cartLevelTitles.has(title)) {
        return false;
      }
      if (targetSelection === 'all' || allocationMethod === 'across') {
        return false;
      }
      return true;
    });
  }
  function getMiniCartItemPropertyValue(item, propertyKeys) {
    const properties = item && item.properties;
    const keys = Array.isArray(propertyKeys) ? propertyKeys : [propertyKeys];
    if (!properties || !keys.length) {
      return '';
    }
    if (Array.isArray(properties)) {
      const matchingProperty = properties.find(property => property && keys.includes(property.first));
      return matchingProperty ? String(matchingProperty.last || '').trim() : '';
    }
    return keys
      .map(key => String(properties[key] || '').trim())
      .find(Boolean) || '';
  }
  function getMiniCartItemBundlePriceData(item) {
    const currencyCode = String((window.PXUTheme && window.PXUTheme.currency && window.PXUTheme.currency.iso_code) || '').trim();
    const bundlePriceRaw = getMiniCartItemPropertyValue(item, [`_bundle_price-${currencyCode}`, '_bundle_price']);
    if (!bundlePriceRaw) {
      return null;
    }
    const bundlePrice = parseInt(bundlePriceRaw, 10);
    if (!Number.isFinite(bundlePrice)) {
      return null;
    }
    const bundleOriginalPriceRaw = getMiniCartItemPropertyValue(item, [`_original_bundle_price-${currencyCode}`, '_original_bundle_price']);
    const bundleOriginalPrice = bundleOriginalPriceRaw ? parseInt(bundleOriginalPriceRaw, 10) : bundlePrice;
    return {
      price: bundlePrice,
      compareAtPrice: Number.isFinite(bundleOriginalPrice) && bundleOriginalPrice > bundlePrice ? bundleOriginalPrice : 0
    };
  }
  function getMiniCartItemBasePriceData(item, productDataByHandle) {
    const bundlePriceData = getMiniCartItemBundlePriceData(item);
    if (bundlePriceData) {
      return bundlePriceData;
    }
    const productData = productDataByHandle[item.handle];
    let variantData = null;
    if (productData && productData.variants && productData.variants.length) {
      const matchingVariant = productData.variants.find(variant => variant.id === item.id || variant.id === item.variant_id);
      if (matchingVariant) {
        variantData = matchingVariant;
      } else {
        variantData = productData;
      }
    } else if (productData) {
      variantData = productData;
    }
    const basePrice = variantData && typeof variantData.price === 'number'
      ? variantData.price
      : (typeof item.original_price === 'number' ? item.original_price : (typeof item.price === 'number' ? item.price : 0));
    const compareAtPrice = variantData && typeof variantData.compare_at_price === 'number' && variantData.compare_at_price > basePrice
      ? variantData.compare_at_price
      : 0;
    return {
      price: basePrice,
      compareAtPrice
    };
  }
  function productDataHasTag(productData, tag) {
    if (!productData || !productData.tags || !tag) {
      return false;
    }
    if (Array.isArray(productData.tags)) {
      return productData.tags.includes(tag);
    }
    return String(productData.tags)
      .split(',')
      .map(value => value.trim())
      .includes(tag);
  }
  function getExistingMiniCartTagState() {
    const tagState = {};
    $('.js-cart_items [data-product-handle]').each((_index, itemEl) => {
      const $item = $(itemEl);
      const handle = String($item.attr('data-product-handle') || '').trim();
      if (!handle) {
        return;
      }
      tagState[handle] = {
        factorySeconds: String($item.attr('data-factory-seconds')) === 'true'
      };
    });
    return tagState;
  }
  function cartItemHasTag(item, productDataByHandle, existingTagState, tag) {
    const productData = productDataByHandle[item.handle];
    if (productDataHasTag(productData, tag)) {
      return true;
    }
    const existingItemState = existingTagState[item.handle];
    if (existingItemState && tag === 'factory-seconds') {
      return existingItemState.factorySeconds === true;
    }
    return false;
  }
  function getMiniCartConditionalRichTextFilters(value) {
    return String(value || '')
      .split(',')
      .map(filter => filter.trim().toLowerCase())
      .filter(Boolean);
  }
  function getMiniCartConditionalRichTextItemTitle(item) {
    return String(item && (item.product_title || item.title) || '')
      .trim()
      .toLowerCase();
  }
  function updateMiniCartConditionalRichTextBlocks(cart) {
    const cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    const isEditorPreview = !!(window.Shopify && window.Shopify.designMode);
    document.querySelectorAll('#mini-cart-drawer [data-mini-cart-conditional-richtext]').forEach(blockEl => {
      const hasProductFilter = String(blockEl.dataset.cartProductFilterActive || '') === 'true';
      const customerTagMatch = String(blockEl.dataset.customerTagMatch || 'true') === 'true';
      let productMatch = true;
      if (hasProductFilter) {
        const productFilters = getMiniCartConditionalRichTextFilters(blockEl.dataset.cartProductTitleFilters);
        productMatch = productFilters.some(filter => cartItems.some(item => getMiniCartConditionalRichTextItemTitle(item).includes(filter)));
      }
      const shouldShow = customerTagMatch && productMatch;
      const $placeholder = $(blockEl).find('[data-mini-cart-richtext-hidden-placeholder]').first();
      if (shouldShow) {
        blockEl.classList.remove('hidden');
        $placeholder.addClass('hidden');
        return;
      }
      if (isEditorPreview) {
        blockEl.classList.remove('hidden');
        $placeholder.removeClass('hidden');
        return;
      }
      blockEl.classList.add('hidden');
      $placeholder.addClass('hidden');
    });
  }
  function renderCartContents(cart, productDataByHandle, existingTagState, refreshToken) {
    if (refreshToken !== latestCartRefreshToken) {
      return;
    }
    let cartItemsHTML = '';
    if (cart.item_count > 0) {
      $.each(cart.items, (index, item) => {
        const itemDiscounts = getVisibleMiniCartLineLevelDiscounts(item, cart);
        const hasLineLevelDiscount = itemDiscounts.length > 0;
        const basePriceData = getMiniCartItemBasePriceData(item, productDataByHandle);
        const itemIsFactorySeconds = cartItemHasTag(item, productDataByHandle, existingTagState, 'factory-seconds');
        const factorySecondsNote = itemIsFactorySeconds
          ? '<div class="mini-cart__item-tag-note mini-cart__item-tag-note--factory-seconds">Factory Seconds</div>'
          : '';
        const lineID = index + 1;
        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-product-handle="${htmlEncode(item.handle || '')}" data-factory-seconds="${itemIsFactorySeconds}">` + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="mini-cart__item-image">' + '<img src="'}${item.image.replace('http:', '')}" alt="${htmlEncode(item.title)}" />` + '</div></a>';
        }
        cartItemsHTML += '<div class="mini-cart__item-content"><div class="mini-cart__item-header"><div class="mini-cart__item-title"><a href="'
          + `${item.url}">${htmlEncode(item.title)}</a>${factorySecondsNote}</div><div class="mini-cart__item-price">`;
        if (item.selling_plan_allocation) {
          item.sellingPlanName = item.selling_plan_allocation.selling_plan.name;
        }
        const baseItemPrice = basePriceData && typeof basePriceData.price === 'number'
          ? basePriceData.price
          : (typeof item.original_price === 'number' ? item.original_price : item.price);
        const baseCompareAtPrice = basePriceData && typeof basePriceData.compareAtPrice === 'number'
          ? basePriceData.compareAtPrice
          : 0;
        if (hasLineLevelDiscount) {
          const itemWasPrice = typeof item.original_price === 'number' ? item.original_price : baseItemPrice;
          const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(itemWasPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else if (baseCompareAtPrice > baseItemPrice) {
          const itemPrice = `${window.Shopify.formatMoney(baseItemPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(baseCompareAtPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(baseItemPrice, $('body').data('money-format'));
          if (baseItemPrice > 0) {
            cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
          }
        }
        cartItemsHTML += '</div></div>';
        if (item.sellingPlanName) {
          cartItemsHTML += `<div class="meta">${item.sellingPlanName}</div>`;
        }
        if (item.properties) {
          cartItemsHTML += '<div class="mini-cart__item-properties">';
          $.each(item.properties, (title, value) => {
            if (value && value !== 'on') {
              cartItemsHTML += `<div class="mini-cart__item-property">${title}: ${value}</div>`;
            }
          });
          cartItemsHTML += '</div>';
        }
        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';
          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }
          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }
        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div></div>';
        cartItemsHTML += `<div class="mini-cart__item-remove"><a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a></div>`;
      });
    }
    $('.js-cart_items').html(cartItemsHTML);
    renderMiniCartSummary(cart);
    initMiniCartRecommendationSliders();
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }
  function updateMiniCartFreeShipping(cart) {
    const moneyFormat = getMiniCartMoneyFormat();
    $('[data-free-shipping]').each(function () {
      const $freeShipping = $(this);
      const threshold = parseInt($freeShipping.data('thresholdCents'), 10);
      if (!threshold) {
        return;
      }
      const remaining = Math.max(threshold - cart.total_price, 0);
      const progress = Math.max(0, Math.min(100, cart.total_price / threshold * 100));
      const remainingHtml = String($freeShipping.data('remainingHtml') || '');
      const completeHtml = String($freeShipping.data('completeHtml') || '');
      const emptyHtml = String($freeShipping.data('emptyHtml') || '');
      const formattedRemaining = window.Shopify.formatMoney(remaining, moneyFormat);
      let nextMessage = completeHtml;
      if (!cart.item_count && emptyHtml) {
        nextMessage = emptyHtml;
      } else if (remaining > 0) {
        nextMessage = remainingHtml.replace('[amount]', formattedRemaining);
      }
      $freeShipping.find('[data-free-shipping-message]').html(nextMessage);
      $freeShipping.find('[data-free-shipping-progress]').css('width', `${progress}%`);
    });
  }
  function updateMiniCartCountSummary(itemCount) {
    $('.cart_content__count-value').text(itemCount);
    $('.cart_content__count-summary').each(function () {
      const $summary = $(this);
      const singularLabel = $summary.data('singular-label') || 'item';
      const pluralLabel = $summary.data('plural-label') || 'items';
      $summary.find('.cart_content__count-label').text(itemCount === 1 ? singularLabel : pluralLabel);
    });
  }
  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    const $cartForm = $('[data-cart-form="mini-cart"]');
    const existingTagState = getExistingMiniCartTagState();
    const refreshToken = ++latestCartRefreshToken;
    $cartForm.data('total-discount', cart.total_discount);
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    updateMiniCartCountSummary(cart.item_count);
    updateMiniCartFreeShipping(cart);
    updateMiniCartContext(cart);
    $('.cart-container').toggleClass('cart--has-items', cart.item_count > 0);
    $('#mini-cart-drawer').toggleClass('cart--has-items', cart.item_count > 0);
    updateMiniCartConditionalRichTextBlocks(cart);
    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
    }
    renderCartContents(cart, cartProductDataCache, existingTagState, refreshToken);
    initMiniCartDynamicProductBlocks(cart);
    refreshMiniCartJoyInline({ delay: 150 });
    if (cart.item_count > 0) {
      const uniqueHandles = [...new Set(cart.items.map(item => item.handle).filter(Boolean))];
      if (uniqueHandles.length) {
        Promise.all(uniqueHandles.map(handle => new Promise(resolve => {
          if (cartProductDataCache[handle]) {
            resolve([handle, cartProductDataCache[handle]]);
            return;
          }
          $.ajax({
            dataType: 'json',
            cache: false,
            url: `${window.Shopify.routes.root}products/${handle}.js`,
            success(data) {
              cartProductDataCache[handle] = data;
              resolve([handle, data]);
            },
            error() {
              resolve([handle, null]);
            }
          });
        }))).then(results => {
          const productDataByHandle = {};
          results.forEach(result => {
            const [handle, data] = result;
            if (data) {
              productDataByHandle[handle] = data;
            }
          });
          renderCartContents(cart, productDataByHandle, existingTagState, refreshToken);
        });
      }
    }
  }
  function getOpenableCartContainer() {
    const $candidates = $('.sticky_nav--stick .cart-container, #header .cart-container, .top-bar .cart-container');
    const $visibleCandidates = $candidates.filter(function () {
      const $candidate = $(this);
      return $candidate.is(':visible') && $candidate.find('.mini_cart:visible').length > 0;
    });
    if ($visibleCandidates.length) {
      return $visibleCandidates.first();
    }
    return $candidates.first();
  }
  function openMiniCartAfterAdd() {
    const $targetCartContainer = getOpenableCartContainer();
    if ($('body').hasClass('fancybox-active')) {
      $.fancybox.close();
    }
    if (window.header && typeof window.header.openMiniCart === 'function') {
      window.header.openMiniCart($targetCartContainer, {
        autoCloseMs: 0
      });
    } else if ($targetCartContainer && $targetCartContainer.length) {
      $('.cart-container').removeClass('active_link');
      $targetCartContainer.addClass('active_link');
    }
    if (window.PXUTheme.media_queries.header_mobile.matches && $targetCartContainer && $targetCartContainer.length) {
      $('body').addClass('blocked-scroll');
      const header = document.getElementById('header');
      if (header && header.classList.contains('mobile_nav-fixed--false')) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
    return $targetCartContainer;
  }
  function syncMiniCartFromServer() {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success(cart) {
        refreshCart(cart);
      }
    });
  }
  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });
  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    cartItem.$element.addClass('animated fadeOutLeft');
    updateCartItemQuantity(cartItem);
    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }
    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });
  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    window.addEventListener('cart:item-added', () => {
      openMiniCartAfterAdd();
      syncMiniCartFromServer();
    });
    $('body').on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');
      const $addToCartText = $addToCartBtn.find('.text').first();
      const originalButtonLabel = $addToCartText.length ? $addToCartText.text() : '';
      this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
      $('.warning').remove();
      if (this.recipientForm) {
        this.recipientForm.classList.remove('recipient-form--has-errors');
      }

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').attr('aria-busy', 'true').addClass('disabled');
          openMiniCartAfterAdd();
        },
        success() {
          $addToCartBtn.removeAttr('disabled').removeAttr('aria-busy').removeClass('disabled');
          syncMiniCartFromServer();
        },
        error: XMLHttpRequest => {
          const response = eval(`(${XMLHttpRequest.responseText})`);
          $('.warning').remove();
          let warning;
          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            warning = `<p class="warning animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
            $addToCartForm.after(warning);
          }
          $addToCartBtn.removeAttr('disabled').removeAttr('aria-busy').removeClass('disabled');
          if ($addToCartText.length && originalButtonLabel) {
            $addToCartText.text(originalButtonLabel);
          }
        }
      });
      return false;
    });
  }
  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });
};
window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
/******/ })()
;
